
export const listViewData = {
    accountingPeriodList: {
        entity: 'accountingPeriod',
        listHeader: { text: 'accountingPeriod.list.title', createButton: 'accountingPeriod.list.new', newPath: 'new' },
        tables: {
            accountingPeriod: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'fromDate',
                columns: [
                    { id: 'name', label: 'accountingPeriod.list.table.name', width: '250px' },
                    { id: 'fromDate', label: 'accountingPeriod.list.table.fromDate', type: 'date', width: '140px' },
                    { id: 'toDate', label: 'accountingPeriod.list.table.toDate', type: 'date', width: '140px' },
                    { id: 'stateName', label: 'accountingPeriod.list.table.state', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'fromDate', type: 'date' },
                        icon: 'lock'
                    },
                    right: {
                        tag: { field: 'stateName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    assetList: {
        entity: 'asset',
        listHeader: { text: 'service.asset.list.title', createButton: 'service.asset.list.new', newPath: 'new' },
        tables: {
            asset: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'service.asset.list.table.name', width: '200px' },
                    { id: 'serialNumber', label: 'service.asset.list.table.serial', width: '150px' },
                    { id: 'model', label: 'service.asset.list.table.model', width: '150px' },
                    { id: 'customerName', label: 'service.asset.list.table.customer', width: '200px' },
                    { id: 'statusName', label: 'service.asset.list.table.status', width: '100px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'serialNumber' },
                        icon: 'factory'
                    },
                    right: {
                        tag: { field: 'customerName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    bomVersionList: {
        entity: 'bomVersion',
        endpoint: 'product/:id/bomVersion',
        listHeader: {
            text: 'bomVersion.list.title',
            createButton: 'bomVersion.list.new',
            newPath: 'bomVersion/new'
        },
        layout: { showNavSpacer: true },
        filters: {
            list: [],
            marginTop: '0rem'
        },
        tables: {
            bomVersion: {
                path: 'bomVersion/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'version',
                columns: [
                    { id: 'version', label: 'bomVersion.list.table.version', width: '100px' },
                    { id: 'description', label: 'bomVersion.list.table.description', width: '300px' },
                    { id: 'statusName', label: 'bomVersion.list.table.status', width: '120px' },
                    { id: 'effectiveFrom', label: 'bomVersion.list.table.from', type: 'date', width: '120px' },
                    { id: 'effectiveTo', label: 'bomVersion.list.table.to', type: 'date', width: '120px' },
                    { id: 'netCost', label: 'bomVersion.list.table.netCost', type: 'amount', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'version' },
                        subTag: { field: 'description' },
                        icon: 'factory'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    campaignList: {
        entity: 'campaign',
        listHeader: {
            text: 'campaign.list.title',
            createButton: 'campaign.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'campaign.list.filter.1' },
                { label: 'campaign.list.filter.2' },
                { label: 'campaign.list.filter.3' }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            campaign: {
                title: 'campaign.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                dropOrder: {
                    800: [1, 2],
                    1024: [2]
                },
                columns: [
                    {
                        id: 'name',
                        label: 'campaign.list.table.name',
                        width: '200px'
                    },
                    {
                        id: 'code',
                        label: 'campaign.list.table.code',
                        width: '150px'
                    },
                    {
                        id: 'startDate',
                        label: 'campaign.list.table.startDate',
                        type: 'date',
                        width: '150px'
                    },
                    {
                        id: 'endDate',
                        label: 'campaign.list.table.endDate',
                        type: 'date',
                        width: '150px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'code' },
                        icon: 'megaphone'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    contactInvoiceList: {
        entity: 'invoice',
        listHeader: {
            entity: 'invoice',
            text: 'invoice.list.title',
            createButton: 'invoice.list.new',
            newPath: 'invoice/new'
        },
        filters: {
            list: [
                {
                    label: 'invoice.list.filter.overdue',
                    entity: 'invoice',
                    applyFilter: true,
                    terms: [
                        { id: 'customerId', value: '{id}' },
                    ]
                },
            ],
            marginTop: '0.5rem'
        },
        tables: {
            invoice: {
                title: 'invoice.list.table.title',
                tableKey: 'id',
                path: '/invoice/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'bookedNumber',
                dropOrder: {
                    885: [3]
                },
                columns: [{
                    id: 'bookedNumber',
                    label: 'invoice.list.table.number',
                    width: '100px'
                },
                {
                    id: 'date',
                    label: 'invoice.list.table.date',
                    type: 'date',
                    width: '100px'
                },
                {
                    id: 'totalGrossSalesAmount',
                    label: 'invoice.list.table.amount',
                    type: 'amount',
                    width: '150px',
                    decorator: 'currency'
                },
                {
                    id: 'paid',
                    label: 'invoice.list.table.paid',
                    type: 'boolean',
                    width: '100px',
                    values: ['invoice.list.table.paid.true', 'invoice.list.table.paid.false']
                }
                ],
                mobile: {
                    left: {
                        tag: { field: 'customerName' },
                        subTag: { field: 'bookedNumber' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totalGrossSalesAmount', type: 'amount' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    contactList: {
        entity: 'contact',
        listHeader: {
            entity: 'contact',
            text: 'contact.list.title',
            createButton: 'contact.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    label: 'contact.list.filter.1',
                    applyFilter: false
                },
                {
                    label: 'contact.list.filter.2',
                    applyFilter: true,
                    terms: [
                        { id: 'companyTypeId', value: 'company' }
                    ]
                },
                {
                    label: 'contact.list.filter.3',
                    applyFilter: true,
                    terms: [
                        { id: 'companyTypeId', value: 'person' }
                    ]
                }
            ],
            marginTop: '0.5rem'
        },
        groupFilters: {
            noFilterLabel: 'product.list.groupFilter.noFilter',
            filters: [
                {
                    label: 'contact.list.groupFilter.contactType.label',
                    endpoint: 'contactType',
                    menuDisplay: 'flat',
                    displayField: 'name',
                    filterField: 'contactType',
                    icon: 'contacts',
                    multiSelect: true
                },
                {
                    label: 'product.list.groupFilter.productGroup.label',
                    endpoint: 'customerGroup',
                    menuDisplay: 'hierarchial',
                    sortField: 'sortKey',
                    hierarchyField: 'type',
                    filterField: 'customerGroup',
                    icon: 'peopleGroup',
                    multiSelect: true
                },
                {
                    label: 'contact.list.groupFilter.currency.label',
                    endpoint: 'currency',
                    menuDisplay: 'flat',
                    filterField: 'currency',
                    icon: 'money',
                    multiSelect: true
                },
                {
                    label: 'contact.list.groupFilter.country.label',
                    endpoint: 'country',
                    menuDisplay: 'flat',
                    filterField: 'country',
                    icon: 'world',
                    multiSelect: true
                }
            ]
        },
        listActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'contact.list.bulk.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'update',
                    label: 'contact.list.bulk.update',
                    confirm: true,
                    modalConfig: 'contactUpdate'
                },
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'edit',
                    label: 'contact.list.line.dropdown.edit'
                },
                {
                    action: 'delete',
                    label: 'contact.list.line.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        tables: {
            contact: {
                title: 'contact.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [{
                    id: 'name',
                    label: 'contact.list.table.name',
                    width: '150px'
                },
                {
                    id: 'email',
                    label: 'contact.list.table.email',
                    width: '250px'
                }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'email' },
                        icon: 'people'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    contactPersonList: {
        entity: 'contactPerson',
        endpoint: 'contact/:id/contactPerson',
        listHeader: {
            text: 'contactPerson.list.title',
            createButton: 'contactPerson.list.new',
            newPath: 'contactPerson/new'
        },
        layout: { showNavSpacer: false },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            contactPerson: {
                path: 'contactPerson/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    {
                        id: 'name',
                        label: 'contactPerson.list.table.name',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'email',
                        label: 'contactPerson.list.table.email',
                        type: 'string',
                        width: '150px'
                    },
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'name',
                            type: 'string'
                        },
                        subTag: {
                            field: 'email'
                        },
                        icon: 'people'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    creditNoteList: {
        entity: 'creditNote',
        listHeader: {
            entity: 'invoice',
            text: 'creditNote.list.title',
            createButton: 'creditNote.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'creditNote.list.filter.draft',
                    entity: 'creditNote',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                        { id: 'archived', value: 'false' }
                    ]
                },
                {
                    slug: 'booked',
                    label: 'creditNote.list.filter.booked',
                    entity: 'creditNote',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'false' }
                    ]
                },
                {
                    slug: 'archived',
                    label: 'creditNote.list.filter.archived',
                    entity: 'creditNote',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'true' }
                    ]
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            creditNote: {
                title: 'creditNote.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'bookedNumber',
                dropOrder: {
                    820: [0, 2, 4],
                    985: [2, 4],
                    1100: [4]
                },
                columns: [{
                    id: 'bookedNumber',
                    label: 'creditNote.list.table.number',
                    width: '100px'
                },
                {
                    id: 'customerName',
                    label: 'creditNote.list.table.customerName',
                    width: '250px'
                },
                {
                    id: 'date',
                    label: 'creditNote.list.table.date',
                    type: 'date',
                    width: '100px'
                },
                {
                    id: 'totalGrossSalesAmount',
                    label: 'creditNote.list.table.amount',
                    type: 'amount',
                    width: '150px',
                    decorator: 'currency'
                },
                {
                    id: 'paid',
                    label: 'invoice.list.table.paid',
                    type: 'boolean',
                    width: '120px',
                    values: ['PAID', 'UNPAID']
                }
                ],
                mobile: {
                    left: {
                        tag: { field: 'customerName' },
                        subTag: { field: 'bookedNumber' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totalGrossSalesAmount', type: 'amount' },
                        subTag: { field: 'date', type: 'date' },
                        status: {
                            success: [{ field: 'paid', value: true }],
                            warning: [{ field: 'paid', value: false }, { field: 'hasPayment', value: true }],
                            error: [{ field: 'hasPayment', value: false }, { field: 'paid', value: false }]
                        }
                    }
                }
            }
        }
    },
    customerGroupList: {
        entity: 'customerGroup',
        listHeader: {
            text: 'customerGroup.list.title',
            createButton: 'customerGroup.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'customerGroup.list.filter.1' },
                { label: 'customerGroup.list.filter.2' },
                { label: 'customerGroup.list.filter.3' }
            ],
            marginTop: '0.5rem'
        },
        listActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'customerGroup.list.bulk.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'edit',
                    label: 'customerGroup.list.dropdown.edit'
                },
                {
                    action: 'delete',
                    label: 'customerGroup.list.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        tables: {
            customerGroup: {
                title: 'customerGroup.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'sortKey',
                dropOrder: {
                    800: [1],
                    1024: [2]
                },
                clickLine: 'expand',
                subLines: {
                    field: 'type',
                    value: 'subGroup',
                    parentField: 'parentId'
                },
                columns: [
                    {
                        id: 'id',
                        label: 'customerGroup.list.table.code',
                        width: '200px'
                    },
                    {
                        id: 'description',
                        label: 'customerGroup.list.table.description',
                        width: '150px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'id' },
                        subTag: { field: 'description' },
                        icon: 'peopleGroup'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    documentList: {
        entity: 'document',
        listHeader: {
            text: 'documents.document.list.title',
            createButton: 'documents.document.list.new',
            newPath: '/documents/document/new'
        },
        folderFilter: true,
        lineActions: {
            menuItems: [
                {
                    action: 'move',
                    label: 'documents.document.list.action.move'
                },
                {
                    action: 'delete',
                    label: 'documents.document.list.action.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
            ]
        },
        tables: {
            document: {
                path: '/document/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                dropOrder: {
                    1000: [2, 3],
                    1200: [3]
                },
                draggable: true,
                columns: [
                    { id: 'name', label: 'documents.document.list.table.name', width: '250px' },
                    { id: 'fileTypeName', label: 'documents.document.list.table.fileType', width: '100px' },
                    { id: 'folderPath', label: 'documents.document.list.table.folderPath', width: '250px' },
                    { id: 'description', label: 'documents.document.list.table.description', width: '300px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'folderPath' },
                        icon: 'document'
                    },
                    right: {
                        tag: { field: 'fileTypeName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    employeeList: {
        entity: 'employee',
        listHeader: {
            text: 'employee.list.title',
            createButton: 'employee.list.new',
            newPath: 'new'
        },
        tables: {
            employee: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'employee.list.table.displayName', width: '200px' },
                    { id: 'title', label: 'employee.list.table.title', width: '180px', shrink: 1 },
                    { id: 'department', label: 'employee.list.table.department', width: '160px' },
                    { id: 'active', label: 'employee.list.table.active', type: 'enum', width: '80px', values: { 'active': 'employee.active.true', 'inactive': 'employee.active.false' } }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'title' },
                        icon: 'people'
                    },
                    right: {
                        tag: { field: 'department' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    expenseList: {
        entity: 'expense',
        listHeader: {
            text: 'purchases.expense.list.title',
            createButton: 'purchases.expense.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'open',
                    label: 'purchases.expense.list.filter.open',
                    entity: 'expense',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                        { id: 'archived', value: 'false' }
                    ],
                    aggregateMatch: { state: 'draft', archived: 'false' },
                    listActions: {
                        menuItems: [
                            {
                                action: 'delete',
                                label: 'purchases.expense.list.bulk.delete',
                                confirm: true,
                                modalConfig: 'expenseConfirmDelete'
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'delete',
                                label: 'purchases.expense.list.line.delete',
                                confirm: true,
                                modalConfig: 'expenseConfirmDelete'
                            }
                        ]
                    }
                },
                {
                    slug: 'booked',
                    label: 'purchases.expense.list.filter.booked',
                    entity: 'expense',
                    table: 'expenseBooked',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'false' }
                    ],
                    aggregateMatch: { state: 'final', archived: 'false' },
                    listActions: {
                        menuItems: [
                            {
                                action: 'archive',
                                label: 'purchases.expense.list.bulk.archive',
                                refreshAggregate: true
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'edit',
                                label: 'purchases.expense.list.line.view'
                            },
                            {
                                action: 'archive',
                                label: 'purchases.expense.list.line.archive',
                                refreshAggregate: true
                            }
                        ]
                    }
                },
                {
                    slug: 'archived',
                    label: 'purchases.expense.list.filter.archived',
                    entity: 'expense',
                    table: 'expenseBooked',
                    applyFilter: true,
                    terms: [
                        { id: 'archived', value: 'true' }
                    ],
                    aggregateMatch: { archived: 'true' },
                    listActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'purchases.expense.list.bulk.unarchive',
                                refreshAggregate: true
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'purchases.expense.list.line.unarchive',
                                refreshAggregate: true
                            }
                        ]
                    }
                }
            ],
            aggregate: 'expense/agr/byState',
            marginTop: '0.5rem'
        },
        listActions: {
            menuItems: [
                {
                    action: 'export',
                    label: 'purchases.expense.list.bulk.export',
                    requiresSelection: false
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'edit',
                    label: 'purchases.expense.list.line.view'
                }
            ]
        },
        tables: {
            expense: {
                title: 'purchases.expense.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                columns: [
                    { id: 'bookedNumber', label: 'purchases.expense.list.table.number', width: '100px' },
                    { id: 'supplierName', label: 'purchases.expense.list.table.supplier', width: '200px' },
                    { id: 'supplierInvoiceNumber', label: 'purchases.expense.list.table.supplierInvoice', width: '130px' },
                    { id: 'date', label: 'purchases.expense.list.table.date', type: 'date', width: '110px' },
                    { id: 'paymentDate', label: 'purchases.expense.list.table.paymentDate', type: 'date', width: '110px' },
                    { id: 'totalGrossAmount', label: 'purchases.expense.list.table.totalAmount', type: 'amount', width: '130px', decorator: 'currency' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'number', type: 'bookedNumber' },
                        subTag: { field: 'supplierName' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totalGrossAmount', type: 'amount' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            },
            // Booked and archived expenses: the same columns, and whether the
            // expense is paid (matchExpensePayment) — the invoice list's column.
            expenseBooked: {
                title: 'purchases.expense.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                columns: [
                    { id: 'bookedNumber', label: 'purchases.expense.list.table.number', width: '100px' },
                    { id: 'supplierName', label: 'purchases.expense.list.table.supplier', width: '200px' },
                    { id: 'supplierInvoiceNumber', label: 'purchases.expense.list.table.supplierInvoice', width: '130px' },
                    { id: 'date', label: 'purchases.expense.list.table.date', type: 'date', width: '110px' },
                    { id: 'paymentDate', label: 'purchases.expense.list.table.paymentDate', type: 'date', width: '110px' },
                    { id: 'totalGrossAmount', label: 'purchases.expense.list.table.totalAmount', type: 'amount', width: '130px', decorator: 'currency' },
                    { id: 'paid', label: 'purchases.expense.list.table.paid', type: 'boolean', width: '120px', values: ['purchases.expense.list.table.paid.true', 'purchases.expense.list.table.paid.false'] }
                ],
                mobile: {
                    left: {
                        tag: { field: 'number', type: 'bookedNumber' },
                        subTag: { field: 'supplierName' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totalGrossAmount', type: 'amount' },
                        subTag: { field: 'date', type: 'date' },
                        status: {
                            success: [{ field: 'paid', value: true }],
                            warning: [{ field: 'paid', value: false }, { field: 'hasPayment', value: true }],
                            error: [{ field: 'hasPayment', value: false }, { field: 'paid', value: false }]
                        }
                    }
                }
            }
        }
    },
    // The journals again, for the grid editor: same records, same tabs. A row
    // opens in the grid while the journal is a draft, read-only once posted.
    fastJournalList: {
        entity: 'journal',
        listHeader: { text: 'journal.fast.list.title', createButton: 'journal.fast.list.new', newPath: 'new' },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'journal.list.filter.draft',
                    entity: 'journal',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' }
                    ]
                },
                {
                    slug: 'posted',
                    label: 'journal.list.filter.posted',
                    entity: 'journal',
                    applyFilter: true,
                    applyMonthFilter: true,
                    terms: [
                        { id: 'state', value: 'posted' }
                    ]
                },
                {
                    slug: 'reversed',
                    label: 'journal.list.filter.reversed',
                    entity: 'journal',
                    applyFilter: true,
                    applyMonthFilter: true,
                    terms: [
                        { id: 'state', value: 'reversed,reversing' }
                    ],
                    lineActions: {
                        menuItems: [
                            {
                                action: 'reverse',
                                label: 'journal.list.line.reverse',
                                confirm: true,
                                modalConfig: 'journalConfirmReverse',
                                condition: { field: 'state', operator: 'equals', value: 'reversing' }
                            }
                        ]
                    }
                },
                {
                    slug: 'all',
                    label: 'journal.list.filter.all',
                    entity: 'journal',
                    applyFilter: false
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            journal: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'accountingDate',
                monthFilterField: 'accountingDate',
                columns: [
                    {
                        id: 'number',
                        label: 'journal.list.table.number',
                        width: '120px'
                    },
                    {
                        id: 'description',
                        label: 'journal.list.table.description',
                        width: '300px'
                    },
                    {
                        id: 'bookId',
                        label: 'journal.list.table.book',
                        width: '100px'
                    },
                    {
                        id: 'accountingDate',
                        label: 'journal.list.table.date',
                        type: 'date',
                        width: '120px'
                    },
                    {
                        id: 'state',
                        label: 'journal.list.table.state',
                        width: '100px'
                    },
                    {
                        id: 'totalDebitBase',
                        label: 'journal.list.table.total',
                        type: 'amount',
                        width: '120px',
                        decorator: 'baseCurrency'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'description' },
                        subTag: { field: 'accountingDate', type: 'date' },
                        icon: 'paper'
                    },
                    right: {
                        tag: { field: 'totalDebitBase', type: 'amount' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    folderList: {
        entity: 'folder',
        listHeader: {
            text: 'documents.folder.list.title',
            createButton: 'documents.folder.list.new',
            newPath: 'new'
        },
        lineActions: {
            menuItems: [
                {
                    action: 'edit',
                    label: 'documents.folder.list.action.edit'
                },
                {
                    action: 'addChild',
                    label: 'documents.folder.list.action.addSubFolder',
                    newPath: '/documents/folder/new',
                    stateFields: [
                        { to: 'parentFolderId', from: 'id' },
                        { to: 'parentFolderName', from: 'name' },
                    ]
                },
                {
                    action: 'delete',
                    label: 'documents.folder.list.action.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        tables: {
            folder: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'path',
                subLines: {
                    parentField: 'parentFolderId',
                    parentValue: null
                },
                columns: [
                    { id: 'name', label: 'documents.folder.list.table.name', width: '200px' },
                    { id: 'path', label: 'documents.folder.list.table.path', width: '350px' },
                    { id: 'description', label: 'documents.folder.list.table.description', width: '300px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'path' },
                        icon: 'folder'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    glAccountList: {
        entity: 'glAccount',
        listHeader: { text: 'glAccount.list.title', createButton: 'glAccount.list.new', newPath: 'new' },
        tables: {
            glAccount: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'number',
                // A chart of accounts is a tree flattened into a list: headings
                // open a group, sums close it, and the accounts anyone actually
                // posts to sit between them. Setting the two structural kinds in
                // bold is what makes that shape visible while scrolling.
                emphasizeLine: {
                    condition: { field: 'accountType', operator: 'in', value: ['header', 'sum'] }
                },
                columns: [
                    { id: 'number', label: 'glAccount.list.table.number', width: '100px' },
                    { id: 'name', label: 'glAccount.list.table.name', width: '300px' },
                    { id: 'categoryName', label: 'glAccount.list.table.category', width: '150px' },
                    { id: 'accountTypeName', label: 'glAccount.list.table.type', width: '120px' },
                    {
                        id: 'active',
                        label: 'glAccount.list.table.active',
                        type: 'boolean',
                        width: '100px',
                        values: ['glAccount.list.table.active.yes', 'glAccount.list.table.active.no']
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'number' },
                        icon: 'books'
                    },
                    right: {
                        tag: { field: 'categoryName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    hallList: {
        entity: 'hall',
        endpoint: 'warehouse/:id/hall',
        listHeader: {
            text: 'warehouse.hall.list.title',
            createButton: 'warehouse.hall.list.new',
            newPath: 'hall/new'
        },
        layout: { showNavSpacer: false },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            hall: {
                path: 'hall/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    {
                        id: 'name',
                        label: 'warehouse.hall.list.table.name',
                        type: 'string',
                        width: '150px'
                    }
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'name',
                            type: 'string'
                        },
                        subTag: {
                            field: 'warehouseName'
                        },
                        icon: 'hall'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    // Purchases › Inbox (38.04): receipts and invoices dropped here, read in the
    // background, and turned into expenses one by one. A document not yet used
    // opens as a new expense from it; a used one opens its expense.
    inboxDocumentList: {
        entity: 'inboxDocument',
        listHeader: {
            text: 'purchases.inbox.list.title'
        },
        dropZone: {
            endpoint: 'file/inbox',
            label: 'purchases.inbox.drop.label',
            accept: '.pdf,.png,.jpg,.jpeg,.gif,.webp'
        },
        filters: {
            list: [
                {
                    slug: 'todo',
                    label: 'purchases.inbox.list.filter.todo',
                    entity: 'inboxDocument',
                    applyFilter: true,
                    terms: [
                        { id: 'status', value: 'new' },
                        { id: 'archived', value: 'false' }
                    ],
                    // Delete takes the uploaded file with it (38.04); a used
                    // document cannot be deleted — its expense holds the file.
                    listActions: {
                        menuItems: [
                            { action: 'delete', label: 'purchases.inbox.list.bulk.delete', confirm: true, modalConfig: 'inboxDocumentConfirmDelete' }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            { action: 'archive', label: 'purchases.inbox.list.line.archive' },
                            { action: 'delete', label: 'purchases.inbox.list.line.delete', confirm: true, modalConfig: 'inboxDocumentConfirmDelete' }
                        ]
                    }
                },
                {
                    slug: 'used',
                    label: 'purchases.inbox.list.filter.used',
                    entity: 'inboxDocument',
                    applyFilter: true,
                    terms: [
                        { id: 'status', value: 'used' },
                        { id: 'archived', value: 'false' }
                    ],
                    // Done with: archived out of sight, one by one or all at once.
                    listActions: {
                        menuItems: [
                            { action: 'archive', label: 'purchases.inbox.list.bulk.archive' }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            { action: 'archive', label: 'purchases.inbox.list.line.archiveUsed' }
                        ]
                    }
                },
                {
                    // Archived documents of both kinds — not expenses, and used
                    // ones put away — by the month of the document's own date.
                    // Restore sends each back where it came from (To do or
                    // Used); delete refuses a used one (its expense's file).
                    slug: 'archived',
                    label: 'purchases.inbox.list.filter.archived',
                    entity: 'inboxDocument',
                    applyFilter: true,
                    applyMonthFilter: true,
                    terms: [
                        { id: 'archived', value: 'true' }
                    ],
                    listActions: {
                        menuItems: [
                            { action: 'unarchive', label: 'purchases.inbox.list.bulk.unarchive' },
                            { action: 'delete', label: 'purchases.inbox.list.bulk.delete', confirm: true, modalConfig: 'inboxDocumentConfirmDelete' }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            { action: 'unarchive', label: 'purchases.inbox.list.line.unarchive' },
                            { action: 'delete', label: 'purchases.inbox.list.line.delete', confirm: true, modalConfig: 'inboxDocumentConfirmDelete' }
                        ]
                    }
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            inboxDocument: {
                title: 'purchases.inbox.list.table.title',
                pathTemplate: [
                    { condition: { field: 'status', operator: 'equals', value: 'used' }, template: '/purchases/expense/{expenseId}' },
                    { template: '/purchases/expense/newFromInbox/{id}' }
                ],
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'uploadedAt',
                direction: 'desc',
                monthFilterField: 'documentDate',
                columns: [
                    { id: 'fileName', label: 'purchases.inbox.list.table.file', width: '200px' },
                    { id: 'supplierName', label: 'purchases.inbox.list.table.supplier', width: '180px' },
                    { id: 'documentDate', label: 'purchases.inbox.list.table.date', type: 'date', width: '110px' },
                    { id: 'total', label: 'purchases.inbox.list.table.total', type: 'amount', width: '130px', decorator: 'currency' },
                    { id: 'readStatus', label: 'purchases.inbox.list.table.read', type: 'enum', width: '120px', values: { pending: 'purchases.inbox.read.pending', done: 'purchases.inbox.read.done', failed: 'purchases.inbox.read.failed' } },
                    { id: 'uploadedAt', label: 'purchases.inbox.list.table.uploaded', type: 'date', width: '110px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'supplierName' },
                        subTag: { field: 'fileName' },
                        icon: 'inbox'
                    },
                    right: {
                        tag: { field: 'total', type: 'amount' },
                        subTag: { field: 'documentDate', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    interactionList: {
        entity: 'interaction',
        endpoint: 'contact/:id/interaction',
        listHeader: {
            text: 'interaction.list.title',
            createButton: 'interaction.list.new',
            newPath: 'interaction/new'
        },
        layout: { showNavSpacer: false },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            interaction: {
                path: 'interaction/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                columns: [
                    {
                        id: 'date',
                        label: 'interaction.list.table.date',
                        type: 'date',
                        width: '100px',
                        shrink: 0
                    },
                    {
                        id: 'title',
                        label: 'interaction.list.table.title',
                        type: 'string',
                        width: '150px',
                        shrink: 1
                    },
                    {
                        id: 'description',
                        label: 'interaction.list.table.description',
                        width: '450px',
                        shrink: 5
                    }
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'title',
                            type: 'string'
                        },
                        subTag: {
                            field: 'description'
                        },
                        icon: 'people'
                    },
                    right: {
                        tag: {
                            field: 'date',
                            type: 'date'
                        },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    inventoryLedgerList: {
        entity: 'inventoryLedger',
        listHeader: {
            text: 'inventory.ledger.list.title'
        },
        filters: {
            list: [
                {
                    slug: 'receipt',
                    label: 'inventory.ledger.list.filter.receipt',
                    entity: 'inventoryLedger',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'receipt' }]
                },
                {
                    slug: 'adjustment',
                    label: 'inventory.ledger.list.filter.adjustment',
                    entity: 'inventoryLedger',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'adjustment' }]
                },
                {
                    slug: 'movement',
                    label: 'inventory.ledger.list.filter.movement',
                    entity: 'inventoryLedger',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'movement_in' }]
                },
                {
                    slug: 'shipment',
                    label: 'inventory.ledger.list.filter.shipment',
                    entity: 'inventoryLedger',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'shipment' }]
                },
                {
                    slug: 'warehouseOrder',
                    label: 'inventory.ledger.list.filter.orders',
                    entity: 'inventoryLedger',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'warehouseOrder' }]
                },
            ],
            marginTop: '0.5rem'
        },
        tables: {
            inventoryLedger: {
                title: 'inventory.ledger.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                dropOrder: {
                    820: [3, 5],
                    985: [5],
                    1100: []
                },
                columns: [
                    {
                        id: 'date',
                        label: 'inventory.ledger.list.table.date',
                        type: 'date',
                        width: '110px'
                    },
                    {
                        id: 'type',
                        label: 'inventory.ledger.list.table.type',
                        width: '120px'
                    },
                    {
                        id: 'itemName',
                        label: 'inventory.ledger.list.table.item',
                        width: '200px'
                    },
                    {
                        id: 'locationId',
                        label: 'inventory.ledger.list.table.location',
                        width: '150px'
                    },
                    {
                        id: 'delta',
                        label: 'inventory.ledger.list.table.delta',
                        type: 'number',
                        width: '100px'
                    },
                    {
                        id: 'documentNumber',
                        label: 'inventory.ledger.list.table.document',
                        width: '120px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'itemName' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'boxes'
                    },
                    right: {
                        tag: { field: 'delta' },
                        subTag: { field: 'type' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    invoiceList: {
        entity: 'invoice',
        listHeader: {
            entity: 'invoice',
            text: 'invoice.list.title',
            createButton: 'invoice.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'invoice.list.filter.draft',
                    entity: 'invoice',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                        { id: 'archived', value: 'false' }
                    ],
                    aggregateMatch: { state: 'draft', archived: 'false' },
                    // Filter-specific actions that only appear in this filter
                    listActions: {
                        menuItems: [
                            {
                                action: 'delete',
                                label: 'invoice.list.bulk.delete',
                                confirm: true,
                                modalConfig: 'invoiceConfirmDelete'
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'delete',
                                label: 'invoice.list.line.delete',
                                confirm: true,
                                modalConfig: 'invoiceConfirmDelete'
                            }
                        ]
                    }
                },
                {
                    slug: 'booked',
                    label: 'invoice.list.filter.booked',
                    entity: 'invoice',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'false' }
                    ],
                    aggregateMatch: { state: 'final', archived: 'false' },
                    // Filter-specific actions for booked invoices
                    listActions: {
                        menuItems: [
                            {
                                action: 'archive',
                                label: 'invoice.list.bulk.archive',
                                refreshAggregate: true
                            },
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'archive',
                                label: 'invoice.list.line.archive',
                                refreshAggregate: true
                            },
                            {
                                action: 'duplicate',
                                label: 'invoice.list.line.duplicate'
                            }
                        ]
                    }
                },
                {
                    label: 'invoice.list.filter.overdue',
                    entity: 'invoicePayment',
                    applyFilter: true,
                    terms: [
                        { id: 'paid', value: 'false' },
                    ],
                    serverTerms: [
                        { id: 'paymentDate', value: '{today}' }
                    ],
                    // Filter-specific actions for overdue invoices
                    listActions: {
                        menuItems: [
                            {
                                action: 'sendReminder',
                                label: 'invoice.list.bulk.sendReminder'
                            }
                        ]
                    }
                },
                {
                    slug: 'archived',
                    label: 'invoice.list.filter.archived',
                    entity: 'invoice',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'true' }
                    ],
                    aggregateMatch: { state: 'final', archived: 'true' },
                    // No filter-specific actions - only global actions will be available
                    listActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'invoice.list.bulk.unarchive',
                                refreshAggregate: true
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'invoice.list.line.unarchive',
                                refreshAggregate: true
                            }
                        ]
                    }
                }
            ],
            aggregate: 'invoice/agr/byState',
            marginTop: '0.5rem'
        },
        // Global actions that appear in all filters
        listActions: {
            menuItems: [
                {
                    action: 'export',
                    label: 'invoice.list.bulk.export',
                    requiresSelection: false
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'edit',
                    label: 'invoice.list.line.view'
                }
            ]
        },
        tables: {
            invoice: {
                title: 'invoice.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'bookedNumber',
                dropOrder: {
                    820: [0, 2, 4],
                    985: [2, 4],
                    1100: [4]
                },
                columns: [{
                    id: 'bookedNumber',
                    label: 'invoice.list.table.number',
                    width: '100px'
                },
                {
                    id: 'customerName',
                    label: 'invoice.list.table.customerName',
                    width: '200px'
                },
                {
                    id: 'date',
                    label: 'invoice.list.table.date',
                    type: 'date',
                    width: '100px'
                },
                {
                    id: 'totalGrossSalesAmount',
                    label: 'invoice.list.table.amount',
                    type: 'amount',
                    width: '150px',
                    decorator: 'currency'
                },
                {
                    id: 'paid',
                    label: 'invoice.list.table.paid',
                    type: 'boolean',
                    width: '120px',
                    values: ['PAID', 'UNPAID']
                }
                ],
                mobile: {
                    left: {
                        tag: { field: 'customerName' },
                        subTag: { field: 'bookedNumber' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totalGrossSalesAmount', type: 'amount' },
                        subTag: { field: 'date', type: 'date' },
                        status: {
                            success: [{ field: 'paid', value: true }],
                            warning: [{ field: 'paid', value: false }, { field: 'hasPayment', value: true }],
                            error: [{ field: 'hasPayment', value: false }, { field: 'paid', value: false }]
                        }
                    }
                }
            },
            invoicePayment: {
                title: 'invoicePayment.list.table.title',
                tableKey: 'invoiceId',
                path: '/invoice/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'paymentDate',
                orderDirection: 'desc',
                dropOrder: {
                    800: [1, 2],
                    1024: [2]
                },
                columns: [{
                    id: 'invoiceNumber',
                    label: 'invoicePayment.list.table.invoice.number',
                    width: '150px'
                },
                {
                    id: 'customerName',
                    label: 'invoicePayment.list.table.customer.name',
                    width: '350px'
                },
                {
                    id: 'paymentDate',
                    label: 'invoicePayment.list.table.payment.date',
                    type: 'date',
                    width: '150px'
                },
                {
                    id: 'paymentAmount',
                    label: 'invoicePayment.list.table.amount',
                    type: 'amount',
                    width: '100px',
                    decorator: 'currency'
                }
                ],
                mobile: {
                    left: {
                        tag: { field: 'customerName' },
                        subTag: { field: 'invoiceNumber' },
                        icon: 'boxes'
                    },
                    right: {
                        tag: { field: 'paymentAmount', type: 'amount' },
                        subTag: { field: 'paymentDate', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    itemLocationList: {
        entity: 'itemLocation',
        endpoint: 'product/:id/itemLocation',
        listHeader: {
            //text: 'bank.account.location.list.title',
            //createButton: 'bank.account.location.list.new'
        },
        layout: { showNavSpacer: false },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            itemLocation: {
                path: '/location/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'locationId',
                columns: [
                    {
                        id: 'locationId',
                        label: 'product.location.list.table.location',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'quantity',
                        label: 'product.location.list.table.quantity',
                        type: 'string',
                        width: '150px',
                        decorator: 'unitName'
                    },
                    {
                        id: 'availableQuantity',
                        label: 'product.location.list.table.quantity.available',
                        type: 'string',
                        width: '150px',
                        decorator: 'unitName'

                    },
                    {
                        id: 'reservedQuantity',
                        label: 'product.location.list.table.quantity.reserved',
                        type: 'quantity',
                        width: '150px',
                        decorator: 'unitName'
                    },
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'quantity',
                            type: 'string'
                        },
                        subTag: {
                            field: 'locationId',
                            type: 'string'
                        },
                        icon: 'pallet'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    itemPriceList: {
        entity: 'itemPrice',
        endpoint: 'product/:id/itemPrice',
        listHeader: {
            text: 'product.price.list.title',
            createButton: 'product.price.list.new',
            newPath: 'itemPrice/new'
        },
        layout: { showNavSpacer: true },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            itemPrice: {
                path: 'itemPrice/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'code',
                columns: [
                    {
                        id: 'code',
                        label: 'product.price.list.table.code',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'netSalesPrice',
                        label: 'product.price.list.table.price',
                        type: 'string',
                        width: '150px',
                        decorator: 'unitName'
                    },
                    {
                        id: 'currency',
                        label: 'product.price.list.table.currency',
                        type: 'string',
                        width: '150px',
                        decorator: 'unitName'
                    }
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'code',
                            type: 'string'
                        },
                        subTag: {
                            field: 'codeName',
                            type: 'string'
                        },
                        icon: 'price'
                    },
                    right: {
                        tag: {
                            field: 'netSalesPrice',
                            type: 'amount'
                        },
                        subTag: {
                            field: 'currency',
                            type: 'string'
                        },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    journalList: {
        entity: 'journal',
        listHeader: { text: 'journal.list.title', createButton: 'journal.list.new', newPath: 'new' },
        // Drafts and posted journals are two different jobs: one is being
        // written, the other is the book. Reversed is kept out of both — it is
        // a correction, and looking for one is its own question.
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'journal.list.filter.draft',
                    entity: 'journal',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' }
                    ]
                },
                // The book itself: it only grows, so it is read a month at a
                // time. Drafts are a working set and short by nature, and the
                // all tab exists precisely to look across months, so neither
                // carries the month filter.
                {
                    slug: 'posted',
                    label: 'journal.list.filter.posted',
                    entity: 'journal',
                    applyFilter: true,
                    applyMonthFilter: true,
                    terms: [
                        { id: 'state', value: 'posted' }
                    ]
                },
                // Both halves of a reversal: the original and the journal that
                // reverses it. They net to zero, so neither belongs among the
                // posted journals — the live book.
                {
                    slug: 'reversed',
                    label: 'journal.list.filter.reversed',
                    entity: 'journal',
                    applyFilter: true,
                    applyMonthFilter: true,
                    terms: [
                        { id: 'state', value: 'reversed,reversing' }
                    ],
                    // Reversing the reversal puts the original's entry back
                    // in the books as a new posted journal. Only the reversing
                    // half offers it: the original is already reversed.
                    lineActions: {
                        menuItems: [
                            {
                                action: 'reverse',
                                label: 'journal.list.line.reverse',
                                confirm: true,
                                modalConfig: 'journalConfirmReverse',
                                condition: { field: 'state', operator: 'equals', value: 'reversing' }
                            }
                        ]
                    }
                },
                {
                    slug: 'all',
                    label: 'journal.list.filter.all',
                    entity: 'journal',
                    applyFilter: false
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            journal: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'accountingDate',
                monthFilterField: 'accountingDate',
                columns: [
                    {
                        id: 'number',
                        label: 'journal.list.table.number',
                        width: '120px'
                    },
                    {
                        id: 'description',
                        label: 'journal.list.table.description',
                        width: '300px'
                    },
                    {
                        id: 'bookId',
                        label: 'journal.list.table.book',
                        width: '100px'
                    },
                    {
                        id: 'accountingDate',
                        label: 'journal.list.table.date',
                        type: 'date',
                        width: '120px'
                    },
                    {
                        id: 'state',
                        label: 'journal.list.table.state',
                        width: '100px'
                    },
                    {
                        // `baseCurrency`, not `transactionCurrency`: the figure is
                        // a base amount (every posting ruleset sums the legs'
                        // baseAmount into it), so the document's own currency was
                        // the wrong code to put beside it — the same mix-up the
                        // journal's display view carried, invisible while the two
                        // match and wrong on every foreign-currency document.
                        id: 'totalDebitBase',
                        label: 'journal.list.table.total',
                        type: 'amount',
                        width: '120px',
                        decorator: 'baseCurrency'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'description' },
                        subTag: { field: 'accountingDate', type: 'date' },
                        icon: 'paper'
                    },
                    right: {
                        tag: { field: 'totalDebitBase', type: 'amount' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    ledgerEntryList: {
        entity: 'ledgerEntry',
        listHeader: { text: 'ledgerEntry.list.title' },
        tables: {
            ledgerEntry: {
                // Rows are immutable, posted G/L rows with nothing further to
                // drill into — clicking one goes to the journal that posted it
                // instead of a (non-existent) ledgerEntry detail page.
                pathTemplate: '/accounting/journal/{journalId}',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'accountingDate',
                columns: [
                    { id: 'accountingDate', label: 'ledgerEntry.list.table.date', type: 'date', width: '120px' },
                    { id: 'accountNo', label: 'ledgerEntry.list.table.accountNo', width: '90px' },
                    { id: 'accountIdName', label: 'ledgerEntry.list.table.account', width: '250px' },
                    { id: 'type', label: 'ledgerEntry.list.table.type', width: '120px' },
                    {
                        id: 'baseAmount',
                        label: 'ledgerEntry.list.table.amount',
                        type: 'amount',
                        width: '140px',
                        decorator: 'baseCurrency'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'accountIdName' },
                        subTag: { field: 'accountingDate', type: 'date' },
                        icon: 'generateList'
                    },
                    right: {
                        tag: { field: 'baseAmount', type: 'amount', decorator: 'baseCurrency' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    locationItemSubList: {
        entity: 'product',
        endpoint: 'product/:id',
        array: 'inventory',
        listHeader: {
            text: 'product.list.title',
            createButton: 'product.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'product.list.filter.1' },
                { label: 'product.list.filter.2' },
                { label: 'product.list.filter.3' }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            product: {
                title: 'product.list.table.title',
                tableKey: 'itemId',
                path: '/product/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                dropOrder: {
                    800: [1, 2],
                    1024: [2]
                },
                columns: [{
                    id: 'itemName',
                    label: 'inventory.location.list.table.product',
                    width: '200px'
                },
                {
                    id: 'itemDescription',
                    label: 'inventory.location.list.table.description',
                    width: '250px'
                },
                {
                    id: 'quantity',
                    label: 'inventory.location.list.table.quantity',
                    width: '75px',
                    decorator: 'unitName'
                },
                {
                    id: 'availableQuantity',
                    label: 'inventory.location.list.table.available',
                    width: '75px',
                    decorator: 'unitName'
                },
                {
                    id: 'reservedQuantity',
                    label: 'inventory.location.list.table.reserved',
                    type: 'quantity',
                    width: '50px',
                    decorator: 'unitName'
                },

                ],
                mobile: {
                    left: {
                        tag: { field: 'itemName' },
                        subTag: { field: 'availableQuantity', decorator: 'unitName' },
                        icon: 'boxes'
                    },
                    right: {
                        tag: { field: 'quantity', decorator: 'unitName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    locationList: {
        entity: 'location',
        listHeader: {
            text: 'location.list.title',
            //createButton: 'location.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        groupFilters: {
            noFilterLabel: 'product.list.groupFilter.noFilter',
            filters: [
                {
                    label: 'inventory.list.groupFilter.warehouse.label',
                    subLabel: 'inventory.list.groupFilter.hall.subLabel',
                    endpoint: 'warehouse',
                    subEndpoint: 'hall',
                    menuDisplay: 'hierarchical',
                    hierarchyField: 'type',
                    parentIdField: 'warehouseId',
                    displayField: 'code',
                    descriptionField: 'name',
                    filterField: 'warehouseId',
                    subFilterField: 'hallId',
                    icon: 'warehouse',
                    multiSelect: true
                },
                {
                    label: 'inventory.list.groupFilter.rack.label',
                    endpoint: 'rack',
                    menuDisplay: 'flat',
                    displayField: 'code',
                    descriptionField: 'name',
                    filterField: 'rackId',
                    icon: 'rack',
                    multiSelect: true
                },
            ]
        },
        tables: {
            location: {
                filter: {
                    type: 'location',
                    entity: 'location',
                    persistValue: true,
                    modalType: 'radioGroup',
                    modalTitle: 'inventory.movement.form.location.modal.title',
                    mobileText: 'remove',
                    radioGroups: [
                        {
                            id: 'warehouse',
                            title: 'inventory.movement.form.location.modal.warehouse',
                            entity: 'warehouse',
                            valueField: 'code',
                            idPrefix: 'W',
                            labelField: 'code',
                            icon: 'warehouse'
                        },
                        {
                            id: 'hall',
                            title: 'inventory.movement.form.location.modal.hall',
                            entity: 'warehouse/:id/hall',
                            dependsOn: 'warehouse',
                            valueField: 'code',
                            labelField: 'code',
                            idPrefix: 'H',
                            icon: 'hall'
                        },
                        {
                            id: 'rack',
                            title: 'inventory.movement.form.location.modal.rack',
                            entity: 'rack',
                            dependsOn: 'warehouse',
                            valueField: 'code',
                            labelField: 'code',
                            icon: 'rack',
                            idPrefix: 'R',
                            columnCount: 6,
                            filter: [
                                { param: 'warehouseCode', groupId: 'warehouse' },
                                { param: 'hallCode', groupId: 'hall' }
                            ],
                            subRadio: [
                                { id: 'level', idPrefix: 'L', valueField: 'totalLevels', title: 'inventory.movement.form.location.modal.level', columnCount: 6, value: 'auto' },
                                { id: 'position', idPrefix: 'P', valueField: 'totalPositions', title: 'inventory.movement.form.location.modal.position', columnCount: 6, value: 'auto' }
                            ]
                        }
                    ]
                },
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'warehouseCode',
                columns: [
                    {
                        id: 'id',
                        label: 'location.list.table.binName',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'warehouseCode',
                        label: 'location.list.table.warehouseCode',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'hallCode',
                        label: 'location.list.table.hallCode',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'rackCode',
                        label: 'location.list.table.rackCode',
                        type: 'string',
                        width: '150px'
                    }
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'id',
                            type: 'string'
                        },
                        subTag: {
                            field: 'warehouseCode'
                        },
                        icon: 'pallet'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    locationReservationSubList: {
        entity: 'reservation',
        array: 'reservations',
        listHeader: {
            text: 'product.list.title',
            createButton: 'product.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'product.list.filter.1' },
                { label: 'product.list.filter.2' },
                { label: 'product.list.filter.3' }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            reservation: {
                title: 'product.list.table.title',
                tableKey: 'reservationId',
                path: '/reservation/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                dropOrder: {
                    800: [1, 2],
                    1024: [2]
                },
                columns: [
                    {
                        id: 'reservationId',
                        label: 'inventory.location.reservation.list.table.id',
                        type: 'code7',
                        width: '250px'
                    },
                    {
                        id: 'itemName',
                        label: 'inventory.location.list.table.product',
                        width: '150px'
                    },
                    {
                        id: 'quantity',
                        label: 'inventory.location.list.table.reserved',
                        width: '100px'
                    },
                    {
                        id: 'activeDocument',
                        label: 'inventory.location.reservation.list.table.doc',
                        type: 'label',
                        width: '150px'
                    },
                    {
                        id: 'documentId',
                        label: 'inventory.location.reservation.list.table.documentId',
                        type: 'code7',
                        width: '250px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'itemName' },
                        subTag: { field: 'reservationId', type: 'code7' },
                        icon: 'lock'
                    },
                    right: {
                        tag: { field: 'quantity' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    machineList: {
        entity: 'machine',
        listHeader: {
            text: 'manufacturing.machine.list.title',
            createButton: 'manufacturing.machine.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'manufacturing.machine.list.filter.all', applyFilter: false },
                { label: 'manufacturing.machine.list.filter.running', applyFilter: true, terms: [{ id: 'status', value: 'running' }] },
                { label: 'manufacturing.machine.list.filter.maintenance', applyFilter: true, terms: [{ id: 'status', value: 'maintenance' }] },
                { label: 'manufacturing.machine.list.filter.down', applyFilter: true, terms: [{ id: 'status', value: 'down' }] }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            machine: {
                title: 'manufacturing.machine.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'manufacturing.machine.list.table.name', width: '200px' },
                    { id: 'code', label: 'manufacturing.machine.list.table.code', width: '100px' },
                    { id: 'workCenterName', label: 'manufacturing.machine.list.table.workCenter', width: '160px' },
                    { id: 'statusName', label: 'manufacturing.machine.list.table.status', width: '120px' },
                    { id: 'lastMaintenanceDate', label: 'manufacturing.machine.list.table.lastMaintenance', type: 'date', width: '140px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'workCenterName' },
                        icon: 'boxes'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    // Studio (30.03.08). The model API answers these with every row at once — an
    // org has a handful of overlays and at most 100 versions — and takes no search
    // or filter parameters, so the filter bar is off rather than inert.
    modelFieldList: {
        entity: 'modelField',
        listHeader: {
            text: 'studio.field.list.title',
            createButton: 'studio.field.list.new',
            newPath: 'new'
        },
        layout: { showFilterBar: false },
        tables: {
            modelField: {
                title: 'studio.field.list.table.title',
                orderBy: 'id',
                columns: [
                    { id: 'label', label: 'studio.field.list.table.label', width: '200px' },
                    { id: 'fieldId', label: 'studio.field.list.table.fieldId', width: '160px' },
                    { id: 'targetName', label: 'studio.field.list.table.target', width: '160px' },
                    { id: 'typeName', label: 'studio.field.list.table.type', width: '100px' },
                    { id: 'shown', label: 'studio.field.list.table.shown', type: 'boolean', width: '110px', values: ['studio.field.list.shown', 'studio.field.list.hidden'] },
                    { id: 'searchable', label: 'studio.field.list.table.searchable', type: 'boolean', width: '110px', values: ['all.value.yes', 'all.value.no'] }
                ],
                mobile: {
                    left: {
                        tag: { field: 'label' },
                        subTag: { field: 'id' },
                        icon: 'sliders'
                    },
                    right: {
                        tag: { field: 'type' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    modelOverlayList: {
        entity: 'modelOverlay',
        listHeader: {
            text: 'studio.overlay.list.title',
            createButton: 'studio.overlay.list.new',
            newPath: 'new'
        },
        layout: { showFilterBar: false },
        tables: {
            modelOverlay: {
                title: 'studio.overlay.list.table.title',
                orderBy: 'id',
                columns: [
                    { id: 'namespace', label: 'studio.overlay.list.table.namespace', width: '110px' },
                    { id: 'modelKeyName', label: 'studio.overlay.list.table.modelKey', width: '280px' },
                    { id: 'isLive', label: 'studio.overlay.list.table.live', type: 'boolean', width: '120px', values: ['studio.overlay.list.live.yes', 'studio.overlay.list.live.no'] },
                    { id: 'notes', label: 'studio.overlay.list.table.notes', width: '280px' },
                    { id: 'savedOn', label: 'studio.overlay.list.table.savedOn', type: 'datetime', width: '160px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'modelKey' },
                        subTag: { field: 'namespace' },
                        icon: 'sliders'
                    },
                    right: {
                        tag: { field: 'savedOn', type: 'datetime' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    modelVersionList: {
        entity: 'modelVersion',
        endpoint: 'model/versions',
        listHeader: {
            text: 'studio.version.list.title'
        },
        layout: { showFilterBar: false },
        // Redeploy an older version from the list: the version's rollback
        // (POST model/versions/:id/rollback). Only a superseded one can be.
        lineActions: {
            menuItems: [
                {
                    action: 'rollback',
                    label: 'studio.version.list.redeploy',
                    confirm: true,
                    modalConfig: 'modelVersionConfirmRollback',
                    condition: { field: 'channel', operator: 'equals', value: 'superseded' }
                }
            ]
        },
        tables: {
            modelVersion: {
                title: 'studio.version.list.table.title',
                orderBy: 'id',
                columns: [
                    { id: 'publishedAt', label: 'studio.version.list.table.publishedAt', type: 'datetime', width: '170px' },
                    { id: 'channel', label: 'studio.version.list.table.channel', width: '120px' },
                    { id: 'description', label: 'studio.version.list.table.description', width: '320px' },
                    { id: 'id', label: 'studio.version.list.table.id', width: '260px' },
                    { id: 'localization', label: 'studio.version.list.table.localization', width: '110px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'publishedAt', type: 'datetime' },
                        subTag: { field: 'id' },
                        icon: 'sync'
                    },
                    right: {
                        tag: { field: 'channel' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    organizationList: {
        entity: 'organization',
        listHeader: {
            text: 'organization.list.title',
            createButton: 'organization.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            organization: {
                title: 'organization.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                dropOrder: {
                    700: [1, 2],
                    1024: [1]
                },
                columns: [
                    {
                        id: 'name',
                        label: 'organization.list.table.name',
                        width: '200px'
                    },
                    {
                        id: 'email',
                        label: 'organization.list.table.email',
                        width: '200px'
                    },
                    {
                        id: 'countryName',
                        label: 'organization.list.table.country',
                        width: '200px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'email' },
                        icon: 'org',
                        iconPadding: '0 0.5rem 0 0'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    paymentAccountList: {
        entity: 'paymentAccount',
        listHeader: {
            text: 'bank.account.list.title',
            createButton: 'bank.account.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'bank.account.list.filter.1' },
                { label: 'bank.account.list.filter.2' },
                { label: 'bank.account.list.filter.3' }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            paymentAccount: {
                title: 'bank.account.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'accountName',
                dropOrder: {
                    800: [1, 2],
                    1024: [2]
                },
                columns: [{
                    id: 'accountName',
                    label: 'bank.account.list.table.account.name',
                    width: '250px'
                },
                {
                    id: 'currency',
                    label: 'bank.account.list.table.currency',
                    width: '100px'
                },
                {
                    id: 'balance',
                    label: 'bank.account.list.table.balance',
                    type: 'amount',
                    width: '100px',
                    decorator: 'currency'
                }
                ],
                mobile: {
                    left: {
                        tag: { field: 'accountName' },
                        subTag: { field: 'currency' },
                        icon: 'bank'
                    },
                    right: {
                        tag: { field: 'balance', type: 'amount' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    paymentTermList: {
        entity: 'paymentTerm',
        listHeader: {
            text: 'paymentTerm.list.title',
            createButton: 'paymentTerm.list.new',
            newPath: 'new'
        },
        layout: { showBackButton: true },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            paymentTerm: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    {
                        id: 'id',
                        label: 'paymentTerm.list.table.id',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'name',
                        label: 'paymentTerm.list.table.name',
                        type: 'string',
                        width: '150px'
                    },
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'name',
                            type: 'string'
                        },
                        subTag: {
                            field: 'email'
                        },
                        icon: 'people'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    paymentTransactionList: {
        entity: 'paymentTransaction',
        endpoint: 'paymentAccount/:id/paymentTransaction',
        listHeader: {
            text: 'bank.account.transaction.list.title',
            createButton: 'bank.account.transaction.list.new',
            newPath: 'transaction/new'
        },
        layout: { showNavSpacer: false },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        // The endpoint above names one account, so both of these are scoped to
        // it: export writes that account's transactions, import reads a
        // statement back into it. Neither needs a paymentAccountId column —
        // the URL already says which account.
        listActions: {
            menuItems: [
                {
                    action: 'export',
                    label: 'bank.account.transaction.list.action.export',
                    requiresSelection: false
                },
                {
                    action: 'import',
                    label: 'bank.account.transaction.list.action.import',
                    requiresSelection: false
                }
            ]
        },
        tables: {
            paymentTransaction: {
                path: 'transaction/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                columns: [
                    {
                        id: 'date',
                        label: 'bank.account.transaction.list.table.date',
                        type: 'date',
                        width: '150px'
                    },
                    {
                        id: 'description',
                        label: 'bank.account.transaction.list.table.description',
                        type: 'string',
                        width: '300px'
                    },
                    {
                        id: 'amount',
                        label: 'bank.account.transaction.list.table.amount',
                        type: 'amount',
                        width: '150px',
                        decorator: 'currency'
                    },
                    {
                        id: 'fullyMatched',
                        label: 'bank.account.transaction.list.table.matched',
                        type: 'boolean',
                        width: '90px',
                        values: ['bank.account.transaction.list.table.matched.true', 'bank.account.transaction.list.table.matched.false']
                    }
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'description',
                            type: 'string'
                        },
                        subTag: {
                            field: 'date',
                            type: 'date'
                        },
                        icon: 'people'
                    },
                    right: {
                        subTag: { field: 'amount', type: 'amount' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    plantList: {
        entity: 'plant',
        listHeader: {
            text: 'manufacturing.plant.list.title',
            createButton: 'manufacturing.plant.list.new',
            newPath: 'new'
        },
        tables: {
            plant: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'manufacturing.plant.list.table.name', width: '200px' },
                    { id: 'code', label: 'manufacturing.plant.list.table.code', width: '100px' },
                    { id: 'warehouseName', label: 'manufacturing.plant.list.table.warehouse', width: '200px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'code' },
                        icon: 'factory'
                    },
                    right: {
                        tag: { field: 'warehouseName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    portalCreditNoteList: {
        entity: 'creditNote',
        listHeader: {
            text: 'portal.nav.creditNotes'
        },
        filters: {
            list: [
                {
                    label: 'creditNote.list.filter.booked',
                    applyFilter: true,
                    terms: [{ id: 'state', value: 'final' }]
                }
            ],
            marginTop: '0rem'
        },
        tables: {
            creditNote: {
                title: 'creditNote.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'bookedNumber',
                dropOrder: {
                    700: [1],
                    900: []
                },
                columns: [
                    { id: 'bookedNumber', label: 'creditNote.list.table.number', width: '120px' },
                    { id: 'date', label: 'creditNote.list.table.date', type: 'date', width: '120px' },
                    { id: 'totalGrossSalesAmount', label: 'creditNote.list.table.amount', type: 'amount', width: '150px', decorator: 'currency' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'bookedNumber' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'creditNote'
                    },
                    right: {
                        tag: { field: 'totalGrossSalesAmount', type: 'amount' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    portalInvoiceList: {
        entity: 'invoice',
        listHeader: {
            text: 'portal.nav.invoices'
        },
        filters: {
            list: [
                {
                    label: 'invoice.list.filter.booked',
                    applyFilter: true,
                    terms: [{ id: 'state', value: 'final' }]
                }
            ],
            marginTop: '0rem'
        },
        tables: {
            invoice: {
                title: 'invoice.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'bookedNumber',
                dropOrder: {
                    700: [1, 3],
                    900: [3]
                },
                columns: [
                    { id: 'bookedNumber', label: 'invoice.list.table.number', width: '120px' },
                    { id: 'date', label: 'invoice.list.table.date', type: 'date', width: '120px' },
                    { id: 'totalGrossSalesAmount', label: 'invoice.list.table.amount', type: 'amount', width: '150px', decorator: 'currency' },
                    { id: 'paid', label: 'invoice.list.table.paid', type: 'boolean', width: '100px', values: ['PAID', 'UNPAID'] }
                ],
                mobile: {
                    left: {
                        tag: { field: 'bookedNumber' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totalGrossSalesAmount', type: 'amount' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    portalList: {
        entity: 'portal',
        listHeader: {
            text: 'portal.list.title',
            createButton: 'portal.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    label: 'portal.list.filter.all',
                    applyFilter: false
                },
                {
                    label: 'portal.list.filter.customer',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'customerPortal' }]
                },
                {
                    label: 'portal.list.filter.supplier',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'supplierPortal' }]
                },
                {
                    label: 'portal.list.filter.invitation',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'invitation' }]
                },
                {
                    label: 'portal.list.filter.joinOrganization',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'joinOrganization' }]
                },
                {
                    label: 'portal.list.filter.resetPassword',
                    applyFilter: true,
                    terms: [{ id: 'type', value: 'resetPassword' }]
                }
            ],
            marginTop: '0rem'
        },
        listActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'portal.list.bulk.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'openUrl',
                    label: 'portal.list.line.open'
                },
                {
                    action: 'edit',
                    label: 'portal.list.line.edit'
                },
                {
                    action: 'delete',
                    label: 'portal.list.line.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        tables: {
            portal: {
                title: 'portal.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                dropOrder: {
                    700: [2, 3, 4],
                    1024: [3, 4]
                },
                columns: [
                    { id: 'name', label: 'portal.list.table.name', width: '200px' },
                    { id: 'typeName', label: 'portal.list.table.type', width: '160px', fallback: 'type' },
                    { id: 'contactName', label: 'portal.list.table.contact', width: '200px', fallback: 'email' },
                    {
                        id: 'enabled',
                        label: 'portal.list.table.enabled',
                        type: 'boolean',
                        width: '100px',
                        values: ['portal.list.table.enabled.true', 'portal.list.table.enabled.false']
                    },
                    { id: 'url', label: 'portal.list.table.url', type: 'url', width: '340px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'contactName' },
                        icon: 'peopleGroup'
                    },
                    right: {
                        tag: { field: 'type' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    postingRuleList: {
        entity: 'postingRule',
        listHeader: { text: 'postingRule.list.title', createButton: 'postingRule.list.new', newPath: 'new' },
        tables: {
            postingRule: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'priority',
                // Name first: type and priority alone left several rules
                // indistinguishable (every self-accounted purchase rule is
                // Purchase / 10). legsText says where each one posts.
                columns: [
                    { id: 'name', label: 'postingRule.list.table.name', width: '260px' },
                    { id: 'typeName', label: 'postingRule.list.table.type', width: '120px' },
                    { id: 'matchText', label: 'postingRule.list.table.appliesWhen', width: '320px' },
                    { id: 'legsText', label: 'postingRule.list.table.legs', width: '200px' },
                    { id: 'bookIdName', label: 'postingRule.list.table.book', width: '100px' },
                    { id: 'priority', label: 'postingRule.list.table.priority', type: 'quantity', width: '90px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'legsText' },
                        icon: 'gear'
                    },
                    right: {
                        tag: { field: 'priority', type: 'quantity' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    priceListItemList: {
        entity: 'priceListItem',
        endpoint: 'priceList/:id/priceListItem',
        listHeader: {
            text: 'priceListItem.list.title'

        },
        layout: { showNavSpacer: false },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        listActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'product.list.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'product.list.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        tables: {
            priceListItem: {
                path: 'priceListItem/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    {
                        id: 'name',
                        label: 'priceListItem.list.table.name',
                        type: 'string',
                        width: '200px'
                    },
                    {
                        id: 'netSalesPrice',
                        label: 'priceListItem.list.table.price',
                        type: 'amount',
                        width: '150px',
                        decorator: 'currency'
                    },
                    {
                        id: 'originalPrice',
                        label: 'priceListItem.list.table.originalPrice',
                        type: 'amount',
                        width: '150px',
                        decorator: 'originalCurrency'
                    },
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'name',
                            type: 'string'
                        },
                        subTag: {
                            field: 'sku',
                            type: 'string'
                        },
                        icon: 'boxes'
                    },
                    right: {
                        tag: {
                            field: 'netSalesPrice',
                            type: 'amount'
                        },
                        subTag: {
                            field: 'currency',
                            type: 'string'
                        },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    priceListList: {
        entity: 'priceList',
        listHeader: {
            text: 'priceList.list.title',
            createButton: 'priceList.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'priceList.list.filter.1' },
                { label: 'priceList.list.filter.2' },
                { label: 'priceList.list.filter.3' }
            ],
            marginTop: '0.5rem'
        },
        listActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'priceList.list.bulk.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'priceList.list.line.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        tables: {
            priceList: {
                title: 'priceList.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'id',
                dropOrder: {
                    800: [2, 3],
                    1024: [3]
                },
                columns: [
                    {
                        id: 'id',
                        label: 'priceList.list.table.code',
                        width: '150px'
                    },
                    {
                        id: 'idName',
                        label: 'priceList.list.table.codeName',
                        width: '200px'
                    },
                    {
                        id: 'typeName',
                        label: 'priceList.list.table.type',
                        width: '150px'
                    },
                    {
                        id: 'modeName',
                        label: 'priceList.list.table.mode',
                        width: '150px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'id' },
                        subTag: { field: 'idName' },
                        icon: 'price'
                    },
                    right: {
                        tag: { field: 'typeName' },
                        subTag: { field: 'modeName' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    productFamilyList: {
        entity: 'productFamily',
        listHeader: {
            text: 'productFamily.list.title',
            createButton: 'productFamily.list.new',
            newPath: 'new'
        },
        tables: {
            productFamily: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'sku', label: 'productFamily.list.table.sku', width: '140px' },
                    { id: 'name', label: 'productFamily.list.table.name', width: '300px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'sku' },
                        icon: 'boxes'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    productFamilyProductList: {
        entity: 'product',
        listHeader: {
            text: 'productFamily.products.list.title',
            createButton: null
        },
        layout: { showFilterBar: false, showNavSpacer: true },
        filters: {
            list: [{
                label: 'productFamily.grid.filter.byFamily',
                applyFilter: true,
                terms: [{ id: 'familyId', value: '{id}' }]
            }]
        },
        tables: {
            product: {
                path: '/inventory/product/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'sku', label: 'product.list.table.sku', width: '140px' },
                    { id: 'name', label: 'product.list.table.name', width: '250px' },
                    { id: 'type', label: 'product.list.table.type', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'sku' },
                        icon: 'boxes'
                    },
                    right: {
                        tag: { field: 'type' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    productGroupList: {
        entity: 'productGroup',
        listHeader: {
            text: 'productGroup.list.title',
            createButton: 'productGroup.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'productGroup.list.filter.1' },
                { label: 'productGroup.list.filter.2' },
                { label: 'productGroup.list.filter.3' }
            ],
            marginTop: '0.5rem'
        },
        listActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'productGroup.list.bulk.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'export',
                    label: 'productGroup.list.action.export',
                    requiresSelection: false
                },
                {
                    action: 'import',
                    label: 'productGroup.list.action.import',
                    requiresSelection: false
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'edit',
                    label: 'productGroup.list.dropdown.edit'
                },
                {
                    action: 'delete',
                    label: 'productGroup.list.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        tables: {
            productGroup: {
                title: 'productGroup.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'sortKey',
                dropOrder: {
                    800: [1],
                    1024: [2]
                },
                clickLine: 'expand',
                subLines: {
                    field: 'type',
                    value: 'subGroup',
                    parentField: 'parentId'
                },
                columns: [
                    {
                        id: 'id',
                        label: 'productGroup.list.table.code',
                        width: '200px'
                    },
                    {
                        id: 'description',
                        label: 'productGroup.list.table.description',
                        width: '150px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'id' },
                        subTag: { field: 'description' },
                        icon: 'peopleGroup'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    productList: {
        entity: 'product',
        listHeader: {
            text: 'product.list.title',
            createButton: 'product.list.new',
            newPath: 'new'
        },
        groupFilters: {
            noFilterLabel: 'product.list.groupFilter.noFilter',
            filters: [
                {
                    label: 'product.list.groupFilter.productGroup.label',
                    endpoint: 'productGroup',
                    filterField: 'productGroup',
                    menuDisplay: 'hierarchial',
                    sortField: 'sortKey',
                    hierarchyField: 'type',
                    parentIdField: 'parentId',
                    icon: 'productGroup',
                    multiSelect: true
                }
            ]
        },
        /*     filters: {
                 list: [
                     { label: 'product.list.filter.1' },
                     { label: 'product.list.filter.2' },
                     { label: 'product.list.filter.3' }
                 ],
                 marginTop: '0.5rem'
             },*/
        listActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'product.list.bulk.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'update',
                    label: 'product.list.bulk.update',
                    confirm: true,
                    modalConfig: 'productUpdate'
                },
                {
                    action: 'export',
                    label: 'product.list.action.bulkExport',
                    requiresSelection: false
                },
                {
                    action: 'import',
                    label: 'product.list.action.import',
                    requiresSelection: false
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'delete',
                    label: 'product.list.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'product.list.action.transactions'
                },
                {
                    action: 'activate',
                    label: 'product.list.action.activities'
                }
            ]
        },
        tables: {
            product: {
                title: 'product.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                dropOrder: {
                    800: [1, 2],
                    1024: [2]
                },
                columns: [{
                    id: 'name',
                    label: 'product.list.table.name',
                    width: '150px'
                },
                {
                    id: 'description',
                    label: 'product.list.table.description',
                    width: '350px'
                },
                {
                    id: 'netSalesPrice',
                    label: 'product.list.table.price',
                    width: '100px'
                }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'description' },
                        icon: 'boxes'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    productPriceListItemList: {
        entity: 'priceListItem',
        endpoint: 'priceList/all/priceListItem',
        listHeader: {
            text: 'product.priceListItem.list.title'
        },
        layout: { showNavSpacer: false },
        filters: {
            list: [
                {
                    label: 'product.priceListItem.list.title',
                    applyFilter: true,
                    serverTerms: [{ id: 'id', value: '{id}' }]
                }
            ],
            marginTop: '0rem'
        },
        tables: {
            priceListItem: {
                pathTemplate: '/sales/priceList/{priceListId}/priceListItem/{id}',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'priceListName',
                columns: [
                    {
                        id: 'priceListName',
                        label: 'product.priceListItem.list.table.priceListName',
                        type: 'string',
                        width: '200px'
                    },
                    {
                        id: 'netSalesPrice',
                        label: 'priceListItem.list.table.price',
                        type: 'amount',
                        width: '150px',
                        decorator: 'currency'
                    },
                    {
                        id: 'originalPrice',
                        label: 'priceListItem.list.table.originalPrice',
                        type: 'amount',
                        width: '150px',
                        decorator: 'originalCurrency'
                    },
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'priceListName',
                            type: 'string'
                        },
                        subTag: {
                            field: 'priceListId',
                            type: 'string'
                        },
                        icon: 'price'
                    },
                    right: {
                        tag: {
                            field: 'netSalesPrice',
                            type: 'amount'
                        },
                        subTag: {
                            field: 'currency',
                            type: 'string'
                        },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    productRoutingVersionList: {
        entity: 'routingVersion',
        endpoint: 'product/:id/routingVersion',
        listHeader: {
            text: 'routingVersion.list.title',
            createButton: 'routingVersion.list.new',
            newPath: 'routingVersion/new'
        },
        layout: { showNavSpacer: false },
        tables: {
            routingVersion: {
                path: 'routingVersion/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'version',
                columns: [
                    { id: 'version', label: 'routingVersion.list.table.version', width: '100px' },
                    { id: 'statusName', label: 'routingVersion.list.table.status', width: '120px' },
                    { id: 'effectiveFrom', label: 'routingVersion.list.table.from', type: 'date', width: '120px' },
                    { id: 'effectiveTo', label: 'routingVersion.list.table.to', type: 'date', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'version' },
                        subTag: null,
                        icon: 'factory'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    projectList: {
        entity: 'project',
        listHeader: {
            text: 'project.list.title',
            createButton: 'project.list.new',
            // Absolute: the new-project route is /project/new, and this list is
            // at /project/project, so a relative 'new' resolved to
            // /project/project/new — which matches /project/project/:id with the
            // id 'new'. The button opened the edit page for a record called
            // "new" and saving it PUT to a 404.
            newPath: '/project/new'
        },
        filters: {
            list: [
                {
                    slug: 'active',
                    label: 'project.list.filter.active',
                    entity: 'project',
                    applyFilter: true,
                    terms: [
                        { id: 'archived', value: 'false' }
                    ],
                    listActions: {
                        menuItems: [
                            {
                                action: 'archive',
                                label: 'project.list.bulk.archive'
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'archive',
                                label: 'project.list.line.archive'
                            }
                        ]
                    }
                },
                {
                    slug: 'archived',
                    label: 'project.list.filter.archived',
                    entity: 'project',
                    applyFilter: true,
                    terms: [
                        { id: 'archived', value: 'true' }
                    ],
                    listActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'project.list.bulk.unarchive'
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'project.list.line.unarchive'
                            }
                        ]
                    }
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            project: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'project.list.table.name', width: '200px' },
                    { id: 'description', label: 'project.list.table.description', width: '300px', shrink: 1 },
                    { id: 'statusName', label: 'project.list.table.status', width: '120px' },
                    { id: 'color', label: 'project.list.table.color', width: '80px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'description' },
                        icon: 'task'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    projectTaskList: {
        entity: 'projectTask',
        endpoint: 'project/:id/projectTask',
        listHeader: {
            text: 'project.task.list.title',
            createButton: 'project.task.list.new',
            newPath: 'projectTask/new'
        },
        layout: { showNavSpacer: false },
        groupFilters: {
            noFilterLabel: 'project.list.groupFilter.noFilter',
            filters: [
                {
                    label: 'project.list.groupFilter.priority',
                    endpoint: 'taskPriority',
                    menuDisplay: 'flat',
                    filterField: 'priority',
                    icon: 'money',
                    multiSelect: true
                },
                {
                    label: 'project.list.groupFilter.status',
                    endpoint: 'taskStatus',
                    menuDisplay: 'flat',
                    filterField: 'status',
                    icon: 'world',
                    multiSelect: true
                }
            ]
        },
        tables: {
            projectTask: {
                path: 'projectTask/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'dueDate',
                columns: [
                    { id: 'title', label: 'project.task.list.table.title', width: '200px', shrink: 1 },
                    { id: 'statusName', label: 'project.task.list.table.status', width: '110px' },
                    { id: 'priorityName', label: 'project.task.list.table.priority', width: '90px' },
                    { id: 'dueDate', label: 'project.task.list.table.dueDate', type: 'date', width: '110px' },
                    { id: 'assigneeName', label: 'project.task.list.table.assigneeName', width: '150px' },
                    { id: 'invoiced', label: 'project.task.list.table.invoiced', type: 'boolean', width: '150px', values: ['project.task.list.table.paid.true', 'project.task.list.table.paid.false'] }
                ],
                mobile: {
                    left: {
                        tag: { field: 'title' },
                        subTag: { field: 'assigneeName' },
                        icon: 'checkMark'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: { field: 'dueDate', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    projectTeamList: {
        entity: 'employee',
        listHeader: {
            text: 'project.team.list.title',
            createButton: null
        },
        queryParams: { app: 'project' },
        tables: {
            employee: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'employee.list.table.displayName', width: '200px' },
                    { id: 'title', label: 'employee.list.table.title', width: '180px', shrink: 1 },
                    { id: 'department', label: 'employee.list.table.department', width: '160px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'title' },
                        icon: 'people'
                    },
                    right: {
                        tag: { field: 'department' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    purchaseOrderList: {
        entity: 'purchaseOrder',
        listHeader: {
            text: 'purchases.purchaseOrder.list.title',
            createButton: 'purchases.purchaseOrder.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'open',
                    label: 'purchases.purchaseOrder.list.filter.open',
                    entity: 'purchaseOrder',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                        { id: 'archived', value: 'false' }
                    ],
                    aggregateMatch: { state: 'draft', archived: 'false' },
                    listActions: {
                        menuItems: [
                            {
                                action: 'delete',
                                label: 'purchases.purchaseOrder.list.bulk.delete',
                                confirm: true,
                                modalConfig: 'purchaseOrderConfirmDelete'
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'delete',
                                label: 'purchases.purchaseOrder.list.line.delete',
                                confirm: true,
                                modalConfig: 'purchaseOrderConfirmDelete'
                            }
                        ]
                    }
                },
                {
                    slug: 'confirmed',
                    label: 'purchases.purchaseOrder.list.filter.confirmed',
                    entity: 'purchaseOrder',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'false' }
                    ],
                    aggregateMatch: { state: 'final', archived: 'false' },
                    listActions: {
                        menuItems: [
                            {
                                action: 'archive',
                                label: 'purchases.purchaseOrder.list.bulk.archive',
                                refreshAggregate: true
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'edit',
                                label: 'purchases.purchaseOrder.list.line.view'
                            },
                            {
                                action: 'archive',
                                label: 'purchases.purchaseOrder.list.line.archive',
                                refreshAggregate: true
                            }
                        ]
                    }
                },
                {
                    slug: 'archived',
                    label: 'purchases.purchaseOrder.list.filter.archived',
                    entity: 'purchaseOrder',
                    applyFilter: true,
                    terms: [
                        { id: 'archived', value: 'true' }
                    ],
                    aggregateMatch: { archived: 'true' },
                    listActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'purchases.purchaseOrder.list.bulk.unarchive',
                                refreshAggregate: true
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'purchases.purchaseOrder.list.line.unarchive',
                                refreshAggregate: true
                            }
                        ]
                    }
                }
            ],
            aggregate: 'purchaseOrder/agr/byState',
            marginTop: '0.5rem'
        },
        listActions: {
            menuItems: [
                {
                    action: 'export',
                    label: 'purchases.purchaseOrder.list.bulk.export',
                    requiresSelection: false
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'edit',
                    label: 'purchases.purchaseOrder.list.line.view'
                }
            ]
        },
        tables: {
            purchaseOrder: {
                title: 'purchases.purchaseOrder.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                columns: [
                    { id: 'bookedNumber', label: 'purchases.purchaseOrder.list.table.number', width: '100px' },
                    { id: 'supplierName', label: 'purchases.purchaseOrder.list.table.supplier', width: '200px' },
                    { id: 'date', label: 'purchases.purchaseOrder.list.table.date', type: 'date', width: '110px' },
                    { id: 'deliveryDate', label: 'purchases.purchaseOrder.list.table.deliveryDate', type: 'date', width: '110px' },
                    { id: 'totalGrossAmount', label: 'purchases.purchaseOrder.list.table.totalAmount', type: 'amount', width: '130px', decorator: 'currency' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'number', type: 'bookedNumber' },
                        subTag: { field: 'supplierName' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totalGrossAmount', type: 'amount' },
                        subTag: { field: 'state' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    purchaseRequestList: {
        entity: 'purchaseRequest',
        listHeader: {
            text: 'purchases.purchaseRequest.list.title',
            createButton: 'purchases.purchaseRequest.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'purchases.purchaseRequest.list.filter.draft',
                    entity: 'purchaseRequest',
                    applyFilter: true,
                    terms: [{ id: 'state', value: 'draft' }],
                    listActions: {
                        menuItems: [{
                            action: 'delete',
                            label: 'purchases.purchaseRequest.list.bulk.delete',
                            confirm: true,
                            modalConfig: 'purchaseRequestConfirmDelete'
                        }]
                    },
                    lineActions: {
                        menuItems: [{
                            action: 'delete',
                            label: 'purchases.purchaseRequest.list.line.delete',
                            confirm: true,
                            modalConfig: 'purchaseRequestConfirmDelete'
                        }]
                    }
                },
                {
                    slug: 'submitted',
                    label: 'purchases.purchaseRequest.list.filter.submitted',
                    entity: 'purchaseRequest',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'submitted' },
                        { id: 'archived', value: 'false' }
                    ],
                    listActions: { menuItems: [] },
                    lineActions: { menuItems: [] }
                },
                {
                    slug: 'archived',
                    label: 'purchases.purchaseRequest.list.filter.archived',
                    entity: 'purchaseRequest',
                    applyFilter: true,
                    terms: [{ id: 'archived', value: 'true' }],
                    listActions: {
                        menuItems: [{
                            action: 'unarchive',
                            label: 'purchases.purchaseRequest.list.bulk.unarchive'
                        }]
                    },
                    lineActions: {
                        menuItems: [{
                            action: 'unarchive',
                            label: 'purchases.purchaseRequest.list.line.unarchive'
                        }]
                    }
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            purchaseRequest: {
                title: 'purchases.purchaseRequest.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'requestedAt',
                columns: [
                    { id: 'number', label: 'purchases.purchaseRequest.list.table.number', type: 'bookedNumber', width: '130px' },
                    { id: 'warehouseName', label: 'purchases.purchaseRequest.list.table.warehouse', width: '180px' },
                    { id: 'requestedBy', label: 'purchases.purchaseRequest.list.table.requestedBy', width: '160px' },
                    { id: 'requestedAt', label: 'purchases.purchaseRequest.list.table.requestedAt', type: 'date', width: '110px' },
                    { id: 'neededDate', label: 'purchases.purchaseRequest.list.table.neededDate', type: 'date', width: '110px' },
                    { id: 'totals.lines', label: 'purchases.purchaseRequest.list.table.lines', type: 'number', width: '80px' },
                    { id: 'totals.estimatedAmount', label: 'purchases.purchaseRequest.list.table.estimatedAmount', type: 'amount', width: '130px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'number', type: 'bookedNumber' },
                        subTag: { field: 'warehouseName' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totals.estimatedAmount', type: 'amount' },
                        subTag: { field: 'stateName' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    qualityCheckList: {
        entity: 'qualityCheck',
        listHeader: {
            text: 'manufacturing.qualityCheck.list.title',
            createButton: 'manufacturing.qualityCheck.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'manufacturing.qualityCheck.list.filter.all', applyFilter: false },
                { label: 'manufacturing.qualityCheck.list.filter.pass', applyFilter: true, terms: [{ id: 'result', value: 'pass' }] },
                { label: 'manufacturing.qualityCheck.list.filter.fail', applyFilter: true, terms: [{ id: 'result', value: 'fail' }] },
                { label: 'manufacturing.qualityCheck.list.filter.pending', applyFilter: true, terms: [{ id: 'result', value: 'pending' }] }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            qualityCheck: {
                title: 'manufacturing.qualityCheck.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                columns: [
                    { id: 'date', label: 'manufacturing.qualityCheck.list.table.date', type: 'date', width: '110px' },
                    { id: 'workOrderNumber', label: 'manufacturing.qualityCheck.list.table.workOrder', width: '130px' },
                    { id: 'productName', label: 'manufacturing.qualityCheck.list.table.product', width: '200px' },
                    { id: 'result', label: 'manufacturing.qualityCheck.list.table.result', width: '100px' },
                    { id: 'inspectorName', label: 'manufacturing.qualityCheck.list.table.inspector', width: '160px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'workOrderNumber' },
                        subTag: { field: 'productName' },
                        icon: 'checkMark'
                    },
                    right: {
                        tag: { field: 'result' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    quoteList: {
        entity: 'quote',
        listHeader: {
            entity: 'quote',
            text: 'quote.list.title',
            createButton: 'quote.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'quote.list.filter.draft',
                    entity: 'quote',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                        { id: 'archived', value: 'false' }
                    ],
                    aggregateMatch: { state: 'draft' },
                    listActions: {
                        menuItems: [
                            {
                                action: 'delete',
                                label: 'quote.list.bulk.delete',
                                confirm: true,
                                modalConfig: 'quoteConfirmDelete'
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'delete',
                                label: 'quote.list.line.delete',
                                confirm: true,
                                modalConfig: 'quoteConfirmDelete'
                            }
                        ]
                    }
                },
                {
                    slug: 'sent',
                    label: 'quote.list.filter.sent',
                    entity: 'quote',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'false' }
                    ],
                    aggregateMatch: { state: 'final' },
                    listActions: {
                        menuItems: [
                            {
                                action: 'archive',
                                label: 'quote.list.bulk.archive'
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'archive',
                                label: 'quote.list.line.archive'
                            },
                            {
                                action: 'duplicate',
                                label: 'quote.list.line.duplicate'
                            }
                        ]
                    }
                },
                {
                    slug: 'archived',
                    label: 'quote.list.filter.archived',
                    entity: 'quote',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'true' }
                    ],
                    listActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'quote.list.bulk.unarchive'
                            }
                        ]
                    },
                    lineActions: {
                        menuItems: [
                            {
                                action: 'unarchive',
                                label: 'quote.list.line.unarchive'
                            }
                        ]
                    }
                }
            ],
            aggregate: 'quote/agr/byState',
            marginTop: '0.5rem'
        },
        listActions: {
            menuItems: [
                {
                    action: 'export',
                    label: 'quote.list.bulk.export',
                    requiresSelection: false
                }
            ]
        },
        lineActions: {
            menuItems: [
                {
                    action: 'edit',
                    label: 'quote.list.line.view'
                }
            ]
        },
        tables: {
            quote: {
                title: 'quote.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'bookedNumber',
                dropOrder: {
                    820: [0, 2],
                    985: [2, 3],
                    1100: [3]
                },
                columns: [
                    {
                        id: 'bookedNumber',
                        label: 'quote.list.table.number',
                        width: '100px'
                    },
                    {
                        id: 'customerName',
                        label: 'quote.list.table.customerName',
                        width: '200px'
                    },
                    {
                        id: 'date',
                        label: 'quote.list.table.date',
                        type: 'date',
                        width: '100px'
                    },
                    {
                        id: 'expiryDate',
                        label: 'quote.list.table.expiryDate',
                        type: 'date',
                        width: '120px'
                    },
                    {
                        id: 'totalGrossSalesAmount',
                        label: 'quote.list.table.amount',
                        type: 'amount',
                        width: '150px',
                        decorator: 'currency'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'customerName' },
                        subTag: { field: 'bookedNumber' },
                        icon: 'quote'
                    },
                    right: {
                        tag: { field: 'totalGrossSalesAmount', type: 'amount' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    rackList: {
        entity: 'rack',
        listHeader: {
            text: 'rack.list.title',
            createButton: 'rack.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        groupFilters: {
            noFilterLabel: 'product.list.groupFilter.noFilter',
            filters: [
                {
                    label: 'inventory.list.groupFilter.warehouse.label',
                    subLabel: 'inventory.list.groupFilter.hall.subLabel',
                    endpoint: 'warehouse',
                    subEndpoint: 'hall',
                    menuDisplay: 'hierarchical',
                    hierarchyField: 'type',
                    parentIdField: 'warehouseId',
                    displayField: 'code',
                    descriptionField: 'name',
                    filterField: 'warehouseId',
                    subFilterField: 'hallId',
                    icon: 'warehouse',
                    multiSelect: true
                }]
        },
        tables: {
            rack: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'code',
                columns: [
                    {
                        id: 'code',
                        label: 'rack.list.table.name',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'warehouseName',
                        label: 'rack.list.table.warehouseName',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'hallName',
                        label: 'rack.list.table.hallName',
                        type: 'string',
                        width: '150px'
                    }
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'name',
                            type: 'string'
                        },
                        subTag: {
                            field: 'warehouseName'
                        },
                        icon: 'rack'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    routingVersionList: {
        entity: 'routingVersion',
        listHeader: {
            text: 'routingVersion.list.title',
            createButton: 'routingVersion.list.new',
            newPath: 'new'
        },
        filters: {
            list: [],
            marginTop: '0rem'
        },
        tables: {
            routingVersion: {
                path: '/routingVersion/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'version',
                columns: [
                    { id: 'productName', label: 'routingVersion.list.table.product', width: '200px' },
                    { id: 'version', label: 'routingVersion.list.table.version', width: '100px' },
                    { id: 'statusName', label: 'routingVersion.list.table.status', width: '120px' },
                    { id: 'effectiveFrom', label: 'routingVersion.list.table.from', type: 'date', width: '120px' },
                    { id: 'effectiveTo', label: 'routingVersion.list.table.to', type: 'date', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'version' },
                        subTag: { field: 'productName' },
                        icon: 'factory'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    selectInvoiceList: {
        entity: 'invoice',
        listHeader: {
            entity: 'invoice',
            newPath: 'new'
        },
        layout: { showTitle: false, showFilterBar: false },
        filters: {
            list: [
                {
                    slug: 'booked',
                    entity: 'invoice',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'archived', value: 'false' }
                    ],
                    showFilter: false
                    // Filter-specific actions for booked invoices
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            invoice: {
                title: 'invoice.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'bookedNumber',
                dropOrder: {
                    820: [0, 2, 4],
                    985: [2, 4],
                    1100: [4]
                },
                columns: [{
                    id: 'bookedNumber',
                    label: 'invoice.list.table.number',
                    width: '100px'
                },
                {
                    id: 'customerName',
                    label: 'invoice.list.table.customerName',
                    width: '200px'
                },
                {
                    id: 'date',
                    label: 'invoice.list.table.date',
                    type: 'date',
                    width: '100px'
                },
                {
                    id: 'totalGrossSalesAmount',
                    label: 'invoice.list.table.amount',
                    type: 'amount',
                    width: '150px',
                    decorator: 'currency'
                },
                {
                    id: 'paid',
                    label: 'invoice.list.table.paymentStatus',
                    type: 'boolean',
                    width: '90px',
                    values: ['PAID', 'UNPAID']
                }
                ],
                mobile: {
                    left: {
                        tag: { field: 'customerName' },
                        subTag: { field: 'bookedNumber' },
                        icon: 'invoice'
                    },
                    right: {
                        tag: { field: 'totalGrossSalesAmount', type: 'amount' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    selectProjectTaskList: {
        entity: 'projectTask',
        endpoint: 'project/:id/projectTask',
        listHeader: { entity: 'projectTask' },
        layout: { showTitle: false, showFilterBar: false },
        filters: {
            list: [
                {
                    slug: 'done',
                    applyFilter: true,
                    terms: [
                        { id: 'status', value: 'done' },
                        { id: 'invoiced', value: 'false' }
                    ],
                    showFilter: false
                }
            ]
        },
        selectAction: {
            label: 'projectInvoiceWizard.step.1.confirm',
            action: 'nextStep'
        },
        tables: {
            projectTask: {
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'dueDate',
                columns: [
                    { id: 'title', label: 'project.task.list.table.title', width: '200px', shrink: 1 },
                    { id: 'description', label: 'project.task.list.table.description', width: '250px', shrink: 1 },
                    { id: 'effortQuantity', label: 'project.task.list.table.effort', width: '100px' },
                    { id: 'effortUnitName', label: 'project.task.list.table.unit', width: '100px' },
                    { id: 'dueDate', label: 'project.task.list.table.dueDate', type: 'date', width: '110px' }
                ],
                mobileColumns: [
                    { id: 'title', label: 'project.task.list.table.title', width: '150px', shrink: 1 },
                    { id: 'effortQuantity', label: 'project.task.list.table.effort', width: '50px' },
                ]
            }
        }
    },
    selectPurchaseOrderList: {
        entity: 'purchaseOrder',
        listHeader: {
            entity: 'purchaseOrder',
            newPath: 'new'
        },
        layout: { showTitle: false, showFilterBar: false },
        filters: {
            list: [
                {
                    slug: 'booked',
                    entity: 'purchaseOrder',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                        { id: 'received', value: false }
                    ],
                    showFilter: false
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            purchaseOrder: {
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                dropOrder: {
                    820: [0, 3],
                    985: [3]
                },
                columns: [
                    { id: 'bookedNumber', label: 'inventory.po.list.table.number', width: '120px' },
                    { id: 'supplierName', label: 'inventory.po.list.table.supplier', width: '220px' },
                    { id: 'date', label: 'inventory.po.list.table.date', type: 'date', width: '110px' },
                    { id: 'deliveryDate', label: 'inventory.po.list.table.deliveryDate', type: 'date', width: '110px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'supplierName' },
                        subTag: { field: 'bookedNumber' },
                        icon: 'receipt'
                    },
                    right: {
                        tag: { field: 'date', type: 'date' },
                        subTag: { field: 'deliveryDate', type: 'date' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceContractList: {
        entity: 'serviceContract',
        listHeader: { text: 'service.serviceContract.list.title', createButton: 'service.serviceContract.list.new', newPath: 'new' },
        tables: {
            serviceContract: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'contractNumber',
                columns: [
                    { id: 'number', label: 'service.serviceContract.list.table.number', type: 'bookedNumber', width: '150px' },
                    { id: 'customerName', label: 'service.serviceContract.list.table.customer', width: '200px' },
                    { id: 'startDate', label: 'service.serviceContract.list.table.startDate', type: 'date', width: '120px' },
                    { id: 'endDate', label: 'service.serviceContract.list.table.endDate', type: 'date', width: '120px' },
                    { id: 'statusName', label: 'service.serviceContract.list.table.status', width: '100px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'contractNumber' },
                        subTag: { field: 'customerName' },
                        icon: 'paper'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceLocationList: {
        entity: 'serviceLocation',
        listHeader: { text: 'service.serviceLocation.list.title', createButton: 'service.serviceLocation.list.new', newPath: 'new' },
        tables: {
            serviceLocation: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'service.serviceLocation.list.table.name', width: '200px' },
                    { id: 'customerName', label: 'service.serviceLocation.list.table.customer', width: '200px' },
                    { id: 'address_city', label: 'service.serviceLocation.list.table.city', width: '150px' },
                    { id: 'statusName', label: 'service.serviceLocation.list.table.status', width: '100px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'customerName' },
                        icon: 'location'
                    },
                    right: {
                        tag: { field: 'address_city' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    servicePartsLineList: {
        entity: 'servicePartsLine',
        endpoint: 'serviceWorkOrder/:id/servicePartsLine',
        listHeader: { text: 'service.servicePartsLine.list.title', createButton: 'service.servicePartsLine.list.new', newPath: 'servicePartsLine/new' },
        layout: { showNavSpacer: false },
        tables: {
            servicePartsLine: {
                path: 'servicePartsLine/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'productName',
                columns: [
                    { id: 'productName', label: 'service.servicePartsLine.list.table.product', width: '200px' },
                    { id: 'quantity', label: 'service.servicePartsLine.list.table.quantity', type: 'quantity', width: '100px' },
                    { id: 'unitCost', label: 'service.servicePartsLine.list.table.unitCost', type: 'amount', width: '120px' },
                    { id: 'billable', label: 'service.servicePartsLine.list.table.billable', type: 'boolean', width: '100px', values: ['Yes', 'No'] }
                ],
                mobile: {
                    left: {
                        tag: { field: 'productName' },
                        subTag: { field: 'quantity', type: 'quantity' },
                        icon: 'boxes'
                    },
                    right: {
                        tag: { field: 'unitCost', type: 'amount' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceSkillList: {
        entity: 'serviceSkill',
        listHeader: {
            text: 'service.serviceSkill.list.title',
            createButton: 'service.serviceSkill.list.new',
            newPath: 'new'
        },
        tables: {
            serviceSkill: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'service.serviceSkill.list.table.name', width: '200px' },
                    { id: 'code', label: 'service.serviceSkill.list.table.code', width: '100px' },
                    { id: 'description', label: 'service.serviceSkill.list.table.description', width: '300px', shrink: 1 }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'code' },
                        icon: 'sliders'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceTechnicianList: {
        entity: 'serviceTechnician',
        listHeader: {
            text: 'service.serviceTechnician.list.title',
            createButton: 'service.serviceTechnician.list.new',
            newPath: 'new'
        },
        tables: {
            serviceTechnician: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'employeeName',
                columns: [
                    { id: 'employeeName', label: 'service.serviceTechnician.list.table.employee', width: '200px' },
                    { id: 'serviceSkillName', label: 'service.serviceTechnician.list.table.serviceSkill', width: '160px' },
                    { id: 'shiftCode', label: 'service.serviceTechnician.list.table.shift', width: '120px' },
                    { id: 'shiftName', label: 'service.serviceTechnician.list.table.shiftName', width: '180px', shrink: 1 }
                ],
                mobile: {
                    left: {
                        tag: { field: 'employeeName' },
                        subTag: { field: 'serviceSkillName' },
                        icon: 'peopleGroup'
                    },
                    right: {
                        tag: { field: 'shiftName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceTicketList: {
        entity: 'serviceTicket',
        listHeader: { text: 'service.serviceTicket.list.title', createButton: 'service.serviceTicket.list.new', newPath: 'new' },
        tables: {
            serviceTicket: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'createdAt',
                columns: [
                    { id: 'number', label: 'service.serviceTicket.list.table.number', type: 'bookedNumber', width: '120px' },
                    { id: 'title', label: 'service.serviceTicket.list.table.title', width: '250px' },
                    { id: 'customerName', label: 'service.serviceTicket.list.table.customer', width: '180px' },
                    { id: 'priorityName', label: 'service.serviceTicket.list.table.priority', width: '100px' },
                    { id: 'statusName', label: 'service.serviceTicket.list.table.status', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'title' },
                        subTag: { field: 'customerName' },
                        icon: 'task'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: { field: 'priorityName' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceTypeList: {
        entity: 'serviceType',
        listHeader: { text: 'service.serviceType.list.title', createButton: 'service.serviceType.list.new', newPath: 'new' },
        tables: {
            serviceType: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'service.serviceType.list.table.name', width: '200px' },
                    { id: 'code', label: 'service.serviceType.list.table.code', width: '100px' },
                    { id: 'categoryName', label: 'service.serviceType.list.table.category', width: '150px' },
                    { id: 'estimatedDuration', label: 'service.serviceType.list.table.duration', type: 'quantity', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'code' },
                        icon: 'sliders'
                    },
                    right: {
                        tag: { field: 'categoryName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceWorkerList: {
        entity: 'employee',
        listHeader: {
            text: 'service.serviceWorker.list.title',
            createButton: null
        },
        queryParams: { app: 'service' },
        tables: {
            employee: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'employee.list.table.displayName', width: '200px' },
                    { id: 'title', label: 'employee.list.table.title', width: '180px', shrink: 1 },
                    { id: 'department', label: 'employee.list.table.department', width: '160px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'title' },
                        icon: 'people'
                    },
                    right: {
                        tag: { field: 'department' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceWorkOrderForTicketList: {
        entity: 'serviceWorkOrder',
        endpoint: 'serviceTicket/:id/serviceWorkOrder',
        listHeader: { text: 'service.workOrder.list.forTicket.title', createButton: 'service.serviceWorkOrder.list.new', newPath: '/service/serviceWorkOrder/new' },
        layout: { showNavSpacer: false },
        tables: {
            serviceWorkOrder: {
                path: '/serviceWorkOrder/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'sequence',
                columns: [
                    { id: 'sequence', label: 'service.serviceWorkOrder.list.table.sequence', width: '60px' },
                    { id: 'title', label: 'service.serviceWorkOrder.list.table.title', width: '220px' },
                    { id: 'serviceSkillName', label: 'service.serviceWorkOrder.list.table.serviceSkill', width: '140px' },
                    { id: 'technicianName', label: 'service.serviceWorkOrder.list.table.technician', width: '160px' },
                    { id: 'scheduledStart', label: 'service.serviceWorkOrder.list.table.scheduledStart', type: 'datetime', width: '140px' },
                    { id: 'statusName', label: 'service.serviceWorkOrder.list.table.status', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'title' },
                        subTag: { field: 'technicianName' },
                        icon: 'task'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: { field: 'scheduledStart', type: 'datetime' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    serviceWorkOrderList: {
        entity: 'serviceWorkOrder',
        listHeader: { text: 'service.serviceWorkOrder.list.title', createButton: 'service.serviceWorkOrder.list.new', newPath: 'new' },
        filters: {
            list: [
                { label: 'service.serviceWorkOrder.list.filter.all', applyFilter: false },
                { label: 'service.serviceWorkOrder.list.filter.draft', applyFilter: true, terms: [{ id: 'status', value: 'draft' }] },
                { label: 'service.serviceWorkOrder.list.filter.scheduled', applyFilter: true, terms: [{ id: 'status', value: 'scheduled' }] },
                { label: 'service.serviceWorkOrder.list.filter.inProgress', applyFilter: true, terms: [{ id: 'status', value: 'in_progress' }] },
                { label: 'service.serviceWorkOrder.list.filter.completed', applyFilter: true, terms: [{ id: 'status', value: 'completed' }] },
                { label: 'service.serviceWorkOrder.list.filter.cancelled', applyFilter: true, terms: [{ id: 'status', value: 'cancelled' }] }
            ],
            marginTop: '0.5rem'
        },
        groupFilters: {
            noFilterLabel: 'service.serviceWorkOrder.list.groupFilter.noFilter',
            filters: [
                {
                    label: 'service.serviceWorkOrder.list.groupFilter.technician',
                    endpoint: 'serviceTechnician',
                    menuDisplay: 'flat',
                    displayField: 'employeeName',
                    filterField: 'technicianId',
                    icon: 'peopleGroup',
                    multiSelect: true
                },
                {
                    label: 'service.serviceWorkOrder.list.groupFilter.status',
                    endpoint: 'serviceWorkOrderStatus',
                    menuDisplay: 'flat',
                    filterField: 'status',
                    icon: 'sliders',
                    multiSelect: true
                }
            ]
        },
        tables: {
            serviceWorkOrder: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'scheduledStart',
                columns: [
                    { id: 'number', label: 'service.serviceWorkOrder.list.table.number', type: 'bookedNumber', width: '120px' },
                    { id: 'customerName', label: 'service.serviceWorkOrder.list.table.customer', width: '180px' },
                    { id: 'technicianName', label: 'service.serviceWorkOrder.list.table.technician', width: '160px' },
                    { id: 'scheduledStart', label: 'service.serviceWorkOrder.list.table.scheduledStart', type: 'datetime', width: '140px' },
                    { id: 'statusName', label: 'service.serviceWorkOrder.list.table.status', width: '120px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'customerName' },
                        subTag: { field: 'technicianName' },
                        icon: 'task'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: { field: 'scheduledStart', type: 'datetime' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    shiftList: {
        entity: 'shift',
        listHeader: {
            text: 'manufacturing.shift.list.title',
            createButton: 'manufacturing.shift.list.new',
            newPath: 'new'
        },
        layout: { showBackButton: true },
        filters: {
            list: [],
            marginTop: '0rem'
        },
        tables: {
            shift: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'code',
                columns: [
                    {
                        id: 'code',
                        label: 'manufacturing.shift.list.table.code',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'name',
                        label: 'manufacturing.shift.list.table.name',
                        type: 'string',
                        width: '300px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'code', type: 'string' },
                        subTag: { field: 'name', type: 'string' },
                        icon: 'sliders'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    stockAdjustmentList: {
        entity: 'stockAdjustment',
        listHeader: {
            entity: 'stockAdjustment',
            text: 'inventory.adjustment.list.title',
            createButton: 'inventory.adjustment.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'inventory.adjustment.list.filter.draft',
                    entity: 'stockAdjustment',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                    ]
                },
                {
                    slug: 'booked',
                    label: 'inventory.adjustment.list.filter.booked',
                    entity: 'stockAdjustment',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                    ]
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            stockAdjustment: {
                title: 'inventory.adjustment.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                dropOrder: {
                    820: [0, 2, 4],
                    985: [2, 4],
                    1100: [4]
                },
                columns: [
                    {
                        id: 'bookedNumber',
                        label: 'inventory.adjustment.list.table.number',
                        type: 'bookedNumber',
                        width: '100px'
                    },
                    {
                        id: 'date',
                        label: 'inventory.adjustment.list.table.date',
                        type: 'date',
                        width: '100px'
                    },
                    {
                        id: 'totalProducts',
                        label: 'inventory.adjustment.list.table.totalProducts',
                        width: '100px'
                    },
                    {
                        id: 'note',
                        label: 'inventory.adjustment.list.table.note',
                        width: '250px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'bookedNumber' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'stockAdjustment'
                    },
                    right: {
                        tag: { field: 'totalProducts' },
                        subTag: { field: 'note' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    stockMovementList: {
        entity: 'stockMovement',
        listHeader: {
            entity: 'stockMovement',
            text: 'inventory.movement.list.title',
            createButton: 'inventory.movement.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'inventory.movement.list.filter.draft',
                    entity: 'stockMovement',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                    ]
                },
                {
                    slug: 'booked',
                    label: 'inventory.movement.list.filter.booked',
                    entity: 'stockMovement',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                    ]
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            stockMovement: {
                title: 'inventory.movement.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                dropOrder: {
                    820: [0, 2, 4],
                    985: [2, 4],
                    1100: [4]
                },
                columns: [
                    {
                        id: 'number',
                        label: 'inventory.movement.list.table.number',
                        type: 'bookedNumber',
                        width: '100px'
                    },
                    {
                        id: 'date',
                        label: 'inventory.movement.list.table.date',
                        type: 'date',
                        width: '100px'
                    },
                    {
                        id: 'note',
                        label: 'inventory.movement.list.table.notes',
                        width: '250px'
                    }

                ],
                mobile: {
                    left: {
                        tag: { field: 'bookedNumber' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'stockMovement'
                    },
                    right: {
                        tag: { field: 'totalProducts' },
                        subTag: { field: 'note' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    stockReceiptList: {
        entity: 'stockReceipt',
        listHeader: {
            entity: 'stockReceipt',
            text: 'inventory.receipt.list.title',
            createButton: 'inventory.receipt.list.new',
            newPath: 'newFromPO'
        },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'inventory.receipt.list.filter.draft',
                    entity: 'stockReceipt',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                    ]
                },
                {
                    slug: 'booked',
                    label: 'inventory.receipt.list.filter.booked',
                    entity: 'stockReceipt',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                    ]
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            stockReceipt: {
                title: 'inventory.receipt.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                dropOrder: {
                    820: [0, 2, 4],
                    985: [2, 4],
                    1100: [4]
                },
                columns: [
                    {
                        id: 'number',
                        label: 'inventory.receipt.list.table.number',
                        type: 'bookedNumber',
                        width: '100px'
                    },
                    {
                        id: 'date',
                        label: 'inventory.receipt.list.table.date',
                        type: 'date',
                        width: '100px'
                    },
                    {
                        id: 'note',
                        label: 'inventory.receipt.list.table.notes',
                        width: '250px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'bookedNumber' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'receipt'
                    },
                    right: {
                        tag: { field: 'totalProducts' },
                        subTag: { field: 'note' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    stockShipmentList: {
        entity: 'stockShipment',
        listHeader: {
            entity: 'stockShipment',
            text: 'inventory.shipment.list.title',
            createButton: 'inventory.shipment.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                {
                    slug: 'draft',
                    label: 'inventory.shipment.list.filter.draft',
                    entity: 'stockShipment',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'draft' },
                    ]
                },
                {
                    slug: 'booked',
                    label: 'inventory.shipment.list.filter.booked',
                    entity: 'stockShipment',
                    applyFilter: true,
                    terms: [
                        { id: 'state', value: 'final' },
                    ]
                }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            stockShipment: {
                title: 'inventory.shipment.list.table.title',
                tableKey: 'id',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                dropOrder: {
                    820: [0, 2, 4],
                    985: [2, 4],
                    1100: [4]
                },
                columns: [
                    {
                        id: 'number',
                        label: 'inventory.shipment.list.table.number',
                        type: 'bookedNumber',
                        width: '100px'
                    },
                    {
                        id: 'date',
                        label: 'inventory.shipment.list.table.date',
                        type: 'date',
                        width: '100px'
                    },
                    {
                        id: 'note',
                        label: 'inventory.shipment.list.table.notes',
                        width: '250px'
                    }

                ],
                mobile: {
                    left: {
                        tag: { field: 'bookedNumber' },
                        subTag: { field: 'date', type: 'date' },
                        icon: 'shipment'
                    },
                    right: {
                        tag: { field: 'totalProducts' },
                        subTag: { field: 'note' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    supplierItemList: {
        entity: 'supplierItem',
        endpoint: 'product/:id/supplierItem',
        listHeader: {
            text: 'supplierItem.list.title',
            createButton: 'supplierItem.list.new',
            newPath: 'supplierItem/new'
        },
        layout: { showNavSpacer: false },
        filters: {
            list: [],
            marginTop: '0rem'
        },
        tables: {
            supplierItem: {
                path: 'supplierItem/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'supplierName',
                columns: [
                    {
                        id: 'supplierName',
                        label: 'supplierItem.list.table.supplierName',
                        type: 'string',
                        width: '200px'
                    },
                    {
                        id: 'supplierSku',
                        label: 'supplierItem.list.table.supplierSku',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'purchaseUnitName',
                        label: 'supplierItem.list.table.purchaseUnit',
                        type: 'string',
                        width: '120px'
                    },
                    {
                        id: 'conversionQuantity',
                        label: 'supplierItem.list.table.conversion',
                        type: 'number',
                        width: '120px'
                    },
                    {
                        id: 'minimumOrderQuantity',
                        label: 'supplierItem.list.table.moq',
                        type: 'number',
                        width: '100px'
                    },
                    {
                        id: 'leadTimeDays',
                        label: 'supplierItem.list.table.leadTime',
                        type: 'number',
                        width: '100px'
                    },
                    {
                        id: 'purchasePrice',
                        label: 'supplierItem.list.table.purchasePrice',
                        type: 'amount',
                        width: '120px',
                        decorator: 'currency'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'supplierName', type: 'string' },
                        subTag: { field: 'supplierSku', type: 'string' },
                        icon: 'people'
                    },
                    right: {
                        tag: { field: 'purchaseUnitName', type: 'string' },
                        subTag: { field: 'conversionQuantity', type: 'number' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    timeEntryList: {
        entity: 'timeEntry',
        endpoint: 'serviceWorkOrder/:id/timeEntry',
        listHeader: { text: 'service.timeEntry.list.title', createButton: 'service.timeEntry.list.new', newPath: 'timeEntry/new' },
        layout: { showNavSpacer: false },
        tables: {
            timeEntry: {
                path: 'timeEntry/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'startTime',
                columns: [
                    { id: 'employeeName', label: 'service.timeEntry.list.table.employee', width: '180px' },
                    { id: 'startTime', label: 'service.timeEntry.list.table.startTime', type: 'date', width: '140px' },
                    { id: 'durationMinutes', label: 'service.timeEntry.list.table.duration', type: 'quantity', width: '120px' },
                    { id: 'billable', label: 'service.timeEntry.list.table.billable', type: 'boolean', width: '100px', values: ['Yes', 'No'] }
                ],
                mobile: {
                    left: {
                        tag: { field: 'employeeName' },
                        subTag: { field: 'startTime', type: 'date' },
                        icon: 'planner'
                    },
                    right: {
                        tag: { field: 'durationMinutes', type: 'quantity' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    userList: {
        entity: 'user',
        listHeader: {
            text: 'user.list.title',
            createButton: 'user.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            user: {
                title: 'user.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    {
                        id: 'name',
                        label: 'user.list.table.name',
                        width: '200px'
                    },
                    {
                        id: 'email',
                        label: 'user.list.table.email',
                        width: '200px'
                    },
                    {
                        id: 'role',
                        label: 'user.list.table.role',
                        width: '200px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'email' },
                        icon: 'people',
                        iconPadding: '0 0.5rem 0 0'
                    },
                    right: {
                        tag: null,
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    warehouseList: {
        entity: 'warehouse',
        listHeader: {
            text: 'warehouse.list.title',
            createButton: 'warehouse.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
            ],
            marginTop: '0rem'
        },
        tables: {
            warehouse: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    {
                        id: 'name',
                        label: 'warehouse.list.table.name',
                        type: 'string',
                        width: '150px'
                    },
                    {
                        id: 'warehouseTypeName',
                        label: 'warehouse.list.table.warehouseTypeName',
                        type: 'string',
                        width: '120px'
                    },
                    {
                        id: 'countryName',
                        label: 'warehouse.list.table.countryName',
                        type: 'string',
                        width: '150px'
                    }
                ],
                mobile: {
                    left: {
                        tag: {
                            field: 'name',
                            type: 'string'
                        },
                        subTag: {
                            field: 'warehouseTypeName'
                        },
                        icon: 'warehouse'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    warehouseOrderList: {
        entity: 'warehouseOrder',
        listHeader: {
            text: 'warehouseOrder.list.title',
            createButton: 'warehouseOrder.list.new',
            newPath: 'new'
        },
        layout: { showBackButton: true },
        filters: {
            list: [
                { slug: 'draft', label: 'warehouseOrder.list.filter.draft', applyFilter: true, serverTerms: [{ id: 'state', value: 'draft' }] },
                { slug: 'released', label: 'warehouseOrder.list.filter.released', applyFilter: true, serverTerms: [{ id: 'state', value: 'released' }, { id: 'completed', value: 'false' }] },
                { slug: 'completed', label: 'warehouseOrder.list.filter.completed', applyFilter: true, serverTerms: [{ id: 'state', value: 'released' }, { id: 'completed', value: 'true' }] },
            ],
            marginTop: '0.5rem'
        },
        lineActions: {
            menuItems: [
                { action: 'edit', label: 'warehouseOrder.list.line.edit' },
                { action: 'delete', label: 'warehouseOrder.list.line.delete', confirm: true, modalConfig: 'confirmDelete' }
            ]
        },
        tables: {
            warehouseOrder: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                direction: 'desc',
                columns: [
                    { id: 'number', label: 'warehouseOrder.list.table.number', width: '110px' },
                    { id: 'date', label: 'warehouseOrder.list.table.date', type: 'date', width: '110px' },
                    { id: 'typeName', label: 'warehouseOrder.list.table.type', width: '130px' },
                    { id: 'state', label: 'warehouseOrder.list.table.status', width: '120px' },
                    { id: 'warehouseName', label: 'warehouseOrder.list.table.warehouse', width: '150px' },
                    { id: 'sourceDocumentNumber', label: 'warehouseOrder.list.table.sourceDoc', width: '130px' },
                    { id: 'assignedToName', label: 'warehouseOrder.list.table.assignedTo', width: '140px' },
                ],
                mobile: {
                    left: {
                        tag: { field: 'number' },
                        subTag: { field: 'typeName' },
                        icon: 'task'
                    },
                    right: {
                        tag: { field: 'state' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    warehouseOrderReleasedList: {
        entity: 'warehouseOrder',
        listHeader: {
            text: 'warehouseOrder.released.title'
        },
        layout: { showBackButton: true },
        filters: {
            list: [
                {
                    slug: 'all',
                    label: 'warehouseOrder.released.filter.all',
                    applyFilter: true,
                    serverTerms: [{ id: 'state', value: 'released' }, { id: 'completed', value: 'false' }]
                },
                {
                    slug: 'pick',
                    label: 'warehouseOrder.released.filter.pick',
                    applyFilter: true,
                    serverTerms: [{ id: 'state', value: 'released' }, { id: 'type', value: 'PICK' }, { id: 'completed', value: 'false' }]
                },
                {
                    slug: 'putaway',
                    label: 'warehouseOrder.released.filter.putaway',
                    applyFilter: true,
                    serverTerms: [{ id: 'state', value: 'released' }, { id: 'type', value: 'PUTAWAY' }, { id: 'completed', value: 'false' }]
                },
                {
                    slug: 'transfer',
                    label: 'warehouseOrder.released.filter.transfer',
                    applyFilter: true,
                    serverTerms: [{ id: 'state', value: 'released' }, { id: 'type', value: 'TRANSFER' }, { id: 'completed', value: 'false' }]
                },
                {
                    slug: 'return',
                    label: 'warehouseOrder.released.filter.return',
                    applyFilter: true,
                    serverTerms: [{ id: 'state', value: 'released' }, { id: 'type', value: 'RETURN' }, { id: 'completed', value: 'false' }]
                },
                {
                    slug: 'quarantine',
                    label: 'warehouseOrder.released.filter.quarantine',
                    applyFilter: true,
                    serverTerms: [{ id: 'state', value: 'released' }, { id: 'type', value: 'QUARANTINE' }, { id: 'completed', value: 'false' }]
                },
            ],
            marginTop: '0rem'
        },
        lineActions: {
            menuItems: [
                { action: 'edit', label: 'warehouseOrder.list.line.edit' },
                { action: 'delete', label: 'warehouseOrder.list.line.delete', confirm: true, modalConfig: 'confirmDelete' }
            ]
        },
        tables: {
            warehouseOrder: {
                pathTemplate: [
                    { condition: { field: 'type', operator: 'equals', value: 'PICK' }, template: '/warehouse/warehouseOrder/pick/{id}' },
                    { condition: { field: 'type', operator: 'equals', value: 'PUTAWAY' }, template: '/warehouse/warehouseOrder/putaway/{id}' },
                    { condition: { field: 'type', operator: 'equals', value: 'TRANSFER' }, template: '/warehouse/warehouseOrder/transfer/{id}' },
                    { condition: { field: 'type', operator: 'equals', value: 'RETURN' }, template: '/warehouse/warehouseOrder/return/{id}' },
                    { condition: { field: 'type', operator: 'equals', value: 'QUARANTINE' }, template: '/warehouse/warehouseOrder/quarantine/{id}' },
                    { template: '/warehouse/warehouseOrder/{id}' }
                ],
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'date',
                direction: 'desc',
                columns: [
                    { id: 'number', label: 'warehouseOrder.list.table.number', width: '110px' },
                    { id: 'date', label: 'warehouseOrder.list.table.date', type: 'date', width: '110px' },
                    { id: 'typeName', label: 'warehouseOrder.list.table.type', width: '130px' },
                    { id: 'warehouseName', label: 'warehouseOrder.list.table.warehouse', width: '150px' },
                    { id: 'sourceDocumentNumber', label: 'warehouseOrder.list.table.sourceDoc', width: '130px' },
                    { id: 'assignedToName', label: 'warehouseOrder.list.table.assignedTo', width: '140px' },
                ],
                mobile: {
                    left: {
                        tag: { field: 'number' },
                        subTag: { field: 'typeName' },
                        icon: 'task'
                    },
                    right: {
                        tag: { field: 'assignedToName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    warehousePathList: {
        entity: 'warehousePath',
        listHeader: {
            text: 'warehousePath.list.title',
            createButton: 'warehousePath.list.new',
            newPath: 'new'
        },
        tables: {
            warehousePath: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'warehousePath.list.table.name', width: '200px' },
                    { id: 'pathType', label: 'warehousePath.list.table.pathType', width: '120px' },
                    { id: 'warehouseCode', label: 'warehousePath.list.table.warehouseCode', width: '100px' }
                ],
                mobile: {
                    left: {
                        tag:    { field: 'name' },
                        subTag: { field: 'pathType' },
                        icon:   'design'
                    },
                    right: {
                        tag:   { field: 'warehouseCode' },
                        subTag: null,
                        icon:  'arrowRight'
                    }
                }
            }
        }
    },
    workCapabilityList: {
        entity: 'workCapability',
        listHeader: {
            text: 'workCapability.list.title',
            createButton: 'workCapability.list.new',
            newPath: 'new'
        },
        tables: {
            workCapability: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'workCapability.list.table.name', width: '200px' },
                    { id: 'code', label: 'workCapability.list.table.code', width: '100px' },
                    { id: 'schedulingModeName', label: 'workCapability.list.table.schedulingMode', width: '120px' },
                    { id: 'isActive', label: 'workCapability.list.table.isActive', type: 'boolean', width: '80px', values: ['ACTIVE', 'INACTIVE'] }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'code' },
                        icon: 'sliders'
                    },
                    right: {
                        tag: { field: 'schedulingMode' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    workCenterList: {
        entity: 'workCenter',
        listHeader: {
            text: 'manufacturing.workCenter.list.title',
            createButton: 'manufacturing.workCenter.list.new',
            newPath: 'new'
        },
        tables: {
            workCenter: {
                title: 'manufacturing.workCenter.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'manufacturing.workCenter.list.table.name', width: '200px' },
                    { id: 'code', label: 'manufacturing.workCenter.list.table.code', width: '100px' },
                    { id: 'description', label: 'manufacturing.workCenter.list.table.description', width: '300px' },
                    { id: 'capacity', label: 'manufacturing.workCenter.list.table.capacity', width: '100px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'code' },
                        icon: 'warehouse'
                    },
                    right: {
                        tag: { field: 'capacity' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    workCenterMachineList: {
        entity: 'machine',
        endpoint: 'workCenter/:id/machine',
        listHeader: {
            text: 'manufacturing.machine.list.title',
            createButton: 'manufacturing.machine.list.new',
            newPath: 'machine/new'
        },
        layout: { showNavSpacer: false },
        tables: {
            machine: {
                path: 'machine/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    { id: 'name', label: 'manufacturing.machine.list.table.name', width: '200px' },
                    { id: 'code', label: 'manufacturing.machine.list.table.code', width: '100px' },
                    { id: 'statusName', label: 'manufacturing.machine.list.table.status', width: '120px' },
                    { id: 'lastMaintenanceDate', label: 'manufacturing.machine.list.table.lastMaintenance', type: 'date', width: '140px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'code' },
                        icon: 'factory'
                    },
                    right: {
                        tag: { field: 'statusName' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    workCenterQueueList: {
        entity: 'workOperation',
        listHeader: {
            text: 'workExecution.queue.title',
            createButton: null,
            newPath: null
        },
        defaultFilters: {
            all: [
                { field: 'plannedStart', operator: 'exists' },
                { field: 'state', operator: 'notIn', value: ['draft', 'completed'] }
            ]
        },
        connectFilter: {
            entity: 'workCenter',
            filterField: 'workCenterId',
            label: 'workExecution.queue.filter.workCenter',
            placeholder: 'workExecution.queue.filter.workCenter.placeholder',
            listDisplay: { text: '${1} - ${2}', params: ['code', 'name'] }
        },
        tables: {
            workOperation: {
                path: '/execution/',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'plannedStart',
                columns: [
                    { id: 'workOrderNumber', label: 'workExecution.queue.table.workOrder', width: '140px' },
                    { id: 'workCenterCode', label: 'workExecution.queue.table.workCenter', width: '130px' },
                    { id: 'name', label: 'workExecution.queue.table.operation', width: '200px' },
                    { id: 'productName', label: 'workExecution.queue.table.product', width: '200px' },
                    { id: 'plannedQty', label: 'workExecution.queue.table.plannedQty', type: 'quantity', width: '75px' },
                    { id: 'completedQty', label: 'workExecution.queue.table.completedQty', type: 'quantity', width: '85px' },
                    { id: 'plannedStart', label: 'workExecution.queue.table.plannedStart', type: 'datetime', width: '150px' },
                    { id: 'plannedEnd', label: 'workExecution.queue.table.plannedEnd', type: 'datetime', width: '150px' },
                    { id: 'stateName', label: 'workExecution.queue.table.stateName', type: 'string', width: '150px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'workOrderNumber' },
                        subTag: { field: 'productName' },
                        icon: 'manufacturing'
                    },
                    right: {
                        tag: { field: 'plannedQty', type: 'quantity' },
                        subTag: { field: 'workCenterCode' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    workDepartmentList: {
        entity: 'workDepartment',
        listHeader: {
            text: 'manufacturing.workDepartment.list.title',
            createButton: 'manufacturing.workDepartment.list.new',
            newPath: 'new'
        },
        layout: { showBackButton: true },
        filters: {
            list: [],
            marginTop: '0rem'
        },
        tables: {
            workDepartment: {
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'name',
                columns: [
                    {
                        id: 'code',
                        label: 'manufacturing.workDepartment.list.table.code',
                        type: 'string',
                        width: '100px'
                    },
                    {
                        id: 'name',
                        label: 'manufacturing.workDepartment.list.table.name',
                        type: 'string',
                        width: '200px'
                    },
                    {
                        id: 'plantName',
                        label: 'manufacturing.workDepartment.list.table.plant',
                        type: 'string',
                        width: '180px'
                    },
                    {
                        id: 'shiftName',
                        label: 'manufacturing.workDepartment.list.table.shift',
                        type: 'string',
                        width: '180px'
                    }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name', type: 'string' },
                        subTag: { field: 'plantName', type: 'string' },
                        icon: 'factory'
                    },
                    right: {
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    workOperationList: {
        entity: 'workOperation',
        endpoint: 'workOrder/:id/workOperation',
        listHeader: { text: 'workOperation.list.title' },
        layout: { showNavSpacer: false },
        listActions: {
            menuItems: [
                { action: 'delete', label: 'workOperation.list.action.delete', confirm: true, modalConfig: 'confirmDelete' }
            ]
        },
        lineActions: {
            menuItems: [
                { action: 'delete', label: 'workOperation.list.action.delete', confirm: true, modalConfig: 'confirmDelete' }
            ]
        },
        tables: {
            workOperation: {
                path: '/workOperation/',
                orderBy: 'sequence',
                columns: [
                    { id: 'sequence', label: 'workOperation.list.table.sequence', type: 'quantity', width: '60px' },
                    { id: 'name', label: 'workOperation.list.table.name', width: '200px' },
                    { id: 'workCapabilityName', label: 'workOperation.list.table.workCapability', width: '150px' },
                    { id: 'workCenterName', label: 'workOperation.list.table.workCenter', width: '150px' },
                    { id: 'stateName', label: 'workOperation.list.table.stateName', width: '120px' },
                    { id: 'totalTime', label: 'workOperation.list.table.totalTime', type: 'quantity', width: '100px' },
                    { id: 'plannedStart', label: 'workOperation.list.table.plannedStart', type: 'datetime', width: '160px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'name' },
                        subTag: { field: 'workCapabilityName' },
                        icon: 'task'
                    },
                    right: {
                        tag: { field: 'sequence', type: 'quantity' },
                        subTag: null,
                        icon: 'arrowRight'
                    }
                }
            }
        }
    },
    workOperationMaterialList: {
        entity: 'workOperationConsumption',
        endpoint: 'workOperation/:id/workOperationConsumption',
        listHeader: { text: 'workExecution.materials.title', createButton: null },
        layout: { showNavSpacer: false },
        tables: {
            workOperationConsumption: {
                orderBy: 'createdAt',
                lineActions: [
                    { label: 'workExecution.materials.action.consume', action: 'modal', modalConfig: 'workOperationRegisterConsumption' }
                ],
                columns: [
                    { id: 'productSku', label: 'workExecution.materials.table.sku', width: '120px' },
                    { id: 'productName', label: 'workExecution.materials.table.product', width: '220px' },
                    { id: 'qty', label: 'workExecution.materials.table.required', type: 'quantity', width: '100px' },
                    { id: 'consumedQty', label: 'workExecution.materials.table.consumed', type: 'quantity', width: '100px' },
                    { id: 'type', label: 'workExecution.materials.table.type', width: '100px' }
                ]
            }
        }
    },
    workOperationOutputList: {
        entity: 'workOperationOutput',
        endpoint: 'workOperation/:id/workOperationOutput',
        listHeader: { text: 'workExecution.outputs.title', createButton: 'workExecution.outputs.new', newPath: null },
        layout: { showNavSpacer: false },
        tables: {
            workOperationOutput: {
                orderBy: 'createdAt',
                columns: [
                    { id: 'productName', label: 'workExecution.outputs.table.product', width: '220px' },
                    { id: 'goodQty', label: 'workExecution.outputs.table.goodQty', type: 'quantity', width: '100px' },
                    { id: 'rejectedQty', label: 'workExecution.outputs.table.rejectedQty', type: 'quantity', width: '100px' },
                    { id: 'createdAt', label: 'workExecution.outputs.table.date', type: 'date', width: '130px' }
                ]
            }
        }
    },
    workOrderList: {
        entity: 'workOrder',
        listHeader: {
            text: 'manufacturing.workOrder.list.title',
            createButton: 'manufacturing.workOrder.list.new',
            newPath: 'new'
        },
        filters: {
            list: [
                { label: 'manufacturing.workOrder.list.filter.all', applyFilter: false },
                { label: 'manufacturing.workOrder.list.filter.draft', applyFilter: true, terms: [{ id: 'state', value: 'draft' }] },
                { label: 'manufacturing.workOrder.list.filter.released', applyFilter: true, terms: [{ id: 'state', value: 'released' }] },
                { label: 'manufacturing.workOrder.list.filter.inProgress', applyFilter: true, terms: [{ id: 'state', value: 'inProgress' }] },
                { label: 'manufacturing.workOrder.list.filter.completed', applyFilter: true, terms: [{ id: 'state', value: 'completed' }] }
            ],
            marginTop: '0.5rem'
        },
        tables: {
            workOrder: {
                title: 'manufacturing.workOrder.list.table.title',
                searchLabel: 'all.list.search',
                searchPlaceholder: 'all.list.search.placeholder',
                orderBy: 'startTime',
                columns: [
                    { id: 'number', label: 'manufacturing.workOrder.list.table.number', width: '120px' },
                    { id: 'productName', label: 'manufacturing.workOrder.list.table.product', width: '200px' },
                    { id: 'plannedQty', label: 'manufacturing.workOrder.list.table.plannedQty', width: '100px' },
                    { id: 'startTime', label: 'manufacturing.workOrder.list.table.startDate', type: 'datetime', width: '150px' },
                    { id: 'endTime', label: 'manufacturing.workOrder.list.table.endDate', type: 'datetime', width: '150px' },
                    { id: 'state', label: 'manufacturing.workOrder.list.table.state', width: '100px' },
                    { id: 'priorityName', label: 'manufacturing.workOrder.list.table.priority', width: '90px' }
                ],
                mobile: {
                    left: {
                        tag: { field: 'number' },
                        subTag: { field: 'productName' },
                        icon: 'task'
                    },
                    right: {
                        tag: { field: 'state' },
                        subTag: { field: 'startTime', type: 'datetime' },
                        icon: 'arrowRight'
                    }
                }
            }
        }
    }
}

export default listViewData
